import { useState, useEffect, useRef } from "react";
import { supabase } from "./supabase";

const theme = {
  greenDeep: "#1a3a2a", greenMid: "#2d6a4f", greenBright: "#52b788",
  greenLight: "#95d5b2", cream: "#f8f4ec", warmWhite: "#fdfaf5",
  accent: "#e07a5f", gold: "#f4a829", textDark: "#1a2418",
  textMid: "#4a5e4a", textLight: "#8fa58f",
};

const PROFILES = [
  { id: 1,  name: "Sophie",  age: 28, city: "London",      postcode: "SW1", looking_for: "Dating",           emoji: "🌿", diet: "Vegan",                  bio: "Yoga teacher and passionate cook. I spend my weekends exploring London's best vegan spots and hiking in the Surrey Hills. Looking for someone who shares a love of good food and good values 🌱",        interests: ["Yoga", "Cooking", "Travel"] },
  { id: 2,  name: "James",   age: 31, city: "Bristol",     postcode: "BS1", looking_for: "Friendship",        emoji: "🥑", diet: "Vegetarian",             bio: "Software dev by day, amateur chef by night. My roasted veg tikka masala has won awards (from my flatmates). Big fan of live music and slow Sunday mornings.",                                         interests: ["Cycling", "Music", "Cooking"] },
  { id: 3,  name: "Priya",   age: 26, city: "Manchester",  postcode: "M1",  looking_for: "Community",         emoji: "🫐", diet: "Vegan",                  bio: "PhD student studying sustainable food systems. I want to change the world one meal at a time. If you like farmers markets, protest marches and strong coffee, we'll get on great.",                   interests: ["Reading", "Hiking", "Activism"] },
  { id: 4,  name: "Ravi",    age: 30, city: "Birmingham",  postcode: "B1",  looking_for: "Activity partner",  emoji: "🏃", diet: "Whole-food plant-based", bio: "Marathon runner and outdoor enthusiast. Went plant-based after reading about factory farming and never looked back. Always planning my next trail run — join me?",                                      interests: ["Running", "Hiking", "Photography"] },
  { id: 5,  name: "Aisha",   age: 29, city: "Edinburgh",   postcode: "EH1", looking_for: "Dating",            emoji: "🎨", diet: "Vegan",                  bio: "Artist and illustrator working in watercolour and print. Life is better without cruelty. I paint, I cook elaborate meals for friends, and I hike every chance I get.",                               interests: ["Art", "Travel", "Meditation"] },
  { id: 6,  name: "Tom",     age: 34, city: "Leeds",       postcode: "LS1", looking_for: "Dating",            emoji: "🌻", diet: "Vegetarian",             bio: "Secondary school teacher who coaches the cross-country team. Huge fan of growing my own veg — my allotment is my therapy. Looking for someone kind and curious.",                                     interests: ["Gardening", "Running", "Film"] },
  { id: 7,  name: "Maya",    age: 27, city: "Brighton",    postcode: "BN1", looking_for: "Dating",            emoji: "🌊", diet: "Vegan",                  bio: "Marine biologist and ocean obsessive. If I'm not in the sea I'm reading about it. I cook big batch curries, adopt rescue dogs, and believe oat milk is not up for debate.",                         interests: ["Swimming", "Animals", "Science"] },
  { id: 8,  name: "Callum",  age: 33, city: "Glasgow",     postcode: "G1",  looking_for: "Friendship",        emoji: "🍄", diet: "Vegan",                  bio: "Chef at a plant-based restaurant. Food is love, full stop. Off-duty I'm into foraging, wild swimming and watching too much football. Looking for someone who'll eat my experiments.",               interests: ["Cooking", "Foraging", "Football"] },
  { id: 9,  name: "Zara",    age: 25, city: "London",      postcode: "E1",  looking_for: "Dating",            emoji: "🌺", diet: "Vegan",                  bio: "Fashion designer trying to make the industry kinder. Thrift shops, botanical gardens and obscure 90s films are my love languages. Bonus points if you have a dog.",                                  interests: ["Fashion", "Art", "Cinema"] },
  { id: 10, name: "Oliver",  age: 36, city: "Oxford",      postcode: "OX1", looking_for: "Dating",            emoji: "📚", diet: "Vegetarian",             bio: "Lecturer in environmental ethics. Passionate about philosophy, long walks and finding the best flat white in every city I visit. Looking for someone equally thoughtful.",                            interests: ["Philosophy", "Walking", "Coffee"] },
  { id: 11, name: "Nia",     age: 24, city: "Cardiff",     postcode: "CF1", looking_for: "Community",         emoji: "🎵", diet: "Vegan",                  bio: "Musician and music teacher. Vegan for the animals, the planet, and honestly — my skin has never been better. Always at a gig or planning one. Let's find a show to go to 🎶",                       interests: ["Music", "Gigs", "Yoga"] },
  { id: 12, name: "Dan",     age: 29, city: "Nottingham",  postcode: "NG1", looking_for: "Activity partner",  emoji: "🚴", diet: "Whole-food plant-based", bio: "Physio and keen cyclist. I got into plant-based eating for performance and stayed for the ethics. Training for a sportive most weekends but always up for brunch after.",                             interests: ["Cycling", "Sport", "Nutrition"] },
  { id: 13, name: "Freya",   age: 31, city: "York",        postcode: "YO1", looking_for: "Friendship",        emoji: "🌙", diet: "Vegan",                  bio: "Freelance writer and chronic bookworm. I write about food, travel and climate. Happiest with a good book, a strong brew and my rescue cat Pesto somewhere nearby.",                                 interests: ["Writing", "Reading", "Travel"] },
  { id: 14, name: "Kieran",  age: 28, city: "Liverpool",   postcode: "L1",  looking_for: "Friendship",        emoji: "⚽", diet: "Vegetarian",             bio: "Graphic designer and lifelong Liverpool fan. Went veggie two years ago and never looked back. I cook, I sketch, I argue about music. Come argue with me.",                                           interests: ["Design", "Football", "Music"] },
  { id: 15, name: "Amara",   age: 32, city: "London",      postcode: "N1",  looking_for: "Dating",            emoji: "🧘", diet: "Vegan",                  bio: "Mindfulness coach and retreat facilitator. I believe how we eat reflects how we live. Looking for someone grounded, warm, and up for spontaneous adventures — big or small.",                        interests: ["Meditation", "Wellness", "Hiking"] },
];

const CHATS = [
  { id: 1, name: "Sophie", emoji: "🌿", lastMsg: "That place sounds amazing! 🌱", time: "2m", unread: 2 },
  { id: 2, name: "James", emoji: "🥑", lastMsg: "I'll bring the hummus 😄", time: "1h", unread: 0 },
  { id: 3, name: "Priya", emoji: "🫐", lastMsg: "Have you tried Mana in Manchester?", time: "3h", unread: 1 },
];

const MESSAGES = [
  { id: 1, from: "them", text: "Hey! I saw you're also into hiking 🌿" },
  { id: 2, from: "me", text: "Yes! I did the Pembrokeshire coast path last summer, it was incredible" },
  { id: 3, from: "them", text: "Oh wow! I've always wanted to do that one. Did you find good vegan food along the way?" },
  { id: 4, from: "me", text: "Better than expected! There's a great little café in St Davids 🥗" },
  { id: 5, from: "them", text: "That place sounds amazing! 🌱" },
];

const FREE_SWIPE_LIMIT = 5;

// ─── AD BANNER ────────────────────────────────────────────────────────────────

const AdBanner = ({ onUpgrade }) => {
  const [dismissed, setDismissed] = useState(false);
  const ads = [
    { brand: "Allplants", copy: "🌱 Get 20% off your first plant-based meal box", cta: "Claim offer", bg: "#e8f5e9", accent: theme.greenMid },
    { brand: "Oatly", copy: "☕ The original oat drink. Try Oatly today.", cta: "Learn more", bg: "#fff8e1", accent: "#f4a829" },
    { brand: "Vegan Life", copy: "📖 Subscribe to Vegan Life magazine — from £3.99", cta: "Subscribe", bg: "#fce4ec", accent: "#e07a5f" },
  ];
  const [adIdx] = useState(Math.floor(Math.random() * ads.length));
  const ad = ads[adIdx];
  if (dismissed) return null;
  return (
    <div style={{ margin: "0 16px 12px", borderRadius: 14, background: ad.bg, border: `1px solid ${ad.accent}22`, padding: "10px 14px", display: "flex", alignItems: "center", gap: 10, position: "relative" }}>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 10, color: theme.textLight, fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: 2 }}>Sponsored · {ad.brand}</div>
        <div style={{ fontSize: 13, color: theme.textDark, fontWeight: 500, lineHeight: 1.4 }}>{ad.copy}</div>
      </div>
      <button style={{ background: ad.accent, color: "white", border: "none", borderRadius: 50, padding: "6px 12px", fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "'DM Sans',sans-serif", whiteSpace: "nowrap" }}>{ad.cta}</button>
      <button onClick={() => setDismissed(true)} style={{ position: "absolute", top: 6, right: 6, background: "none", border: "none", fontSize: 14, color: theme.textLight, cursor: "pointer", lineHeight: 1 }}>✕</button>
    </div>
  );
};

// ─── INTERSTITIAL AD ─────────────────────────────────────────────────────────

const InterstitialAd = ({ onClose, onUpgrade }) => (
  <div style={{ position: "absolute", inset: 0, background: "rgba(26,58,42,0.85)", backdropFilter: "blur(4px)", zIndex: 50, display: "flex", alignItems: "center", justifyContent: "flex-start", padding: 24, borderRadius: 44 }}>
    <div style={{ background: "white", borderRadius: 24, overflow: "hidden", width: "100%" }}>
      <div style={{ background: "linear-gradient(135deg,#e8f5e9,#d4edda)", padding: "28px 24px 20px", textAlign: "center" }}>
        <div style={{ fontSize: 10, color: theme.textLight, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 8 }}>Advertisement</div>
        <div style={{ fontSize: 40, marginBottom: 12 }}>🌿</div>
        <div style={{ fontFamily: "Georgia,serif", fontSize: 20, fontWeight: 700, color: theme.greenDeep, marginBottom: 6 }}>Allplants Meal Boxes</div>
        <p style={{ fontSize: 14, color: theme.textMid, lineHeight: 1.55 }}>100% plant-based meals delivered to your door. Chef-crafted, frozen fresh. <strong>20% off your first box.</strong></p>
      </div>
      <div style={{ padding: "16px 24px 20px", display: "flex", flexDirection: "column", gap: 10 }}>
        <button style={{ ...btnPrimary, background: theme.greenMid }}>Claim 20% off →</button>
        <div style={{ display: "flex", gap: 10 }}>
          <button onClick={onClose} style={{ flex: 1, padding: "10px", borderRadius: 50, border: `1px solid rgba(82,183,136,0.25)`, background: "none", color: theme.textMid, fontFamily: "'DM Sans',sans-serif", fontSize: 13, cursor: "pointer" }}>Skip ad</button>
          <button onClick={onUpgrade} style={{ flex: 1, padding: "10px", borderRadius: 50, border: "none", background: theme.greenDeep, color: "white", fontFamily: "'DM Sans',sans-serif", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>Remove ads 👑</button>
        </div>
      </div>
    </div>
  </div>
);

// ─── PAYWALL ──────────────────────────────────────────────────────────────────

const Paywall = ({ onClose, onSubscribe, trigger = "generic" }) => {
  const [selected, setSelected] = useState("quarterly");
  const triggerMessages = {
    swipes:   { icon: "💚", title: "You're out of daily likes!", sub: "Free members get 5 likes per day. Upgrade for unlimited." },
    wholiked: { icon: "👀", title: "See who liked you", sub: "12 people have already liked your profile. Find out who!" },
    rewind:   { icon: "↩️", title: "Oops! Undo that swipe", sub: "Upgrade to rewind your last swipe anytime." },
    generic:  { icon: "👑", title: "Upgrade to MeetFree Gold", sub: "Get the most out of your plant-based dating journey." },
  };
  const msg = triggerMessages[trigger] || triggerMessages.generic;
  const plans = [
    { id: "monthly",   label: "1 Month",   price: "£9.99", per: "/month",  badge: null },
    { id: "quarterly", label: "3 Months",  price: "£6.99", per: "/month",  badge: "Most popular" },
    { id: "annual",    label: "12 Months", price: "£4.99", per: "/month",  badge: "Best value" },
  ];
  const features = ["💚 Unlimited daily likes","👀 See who liked you","↩️ Unlimited rewinds","🚀 1 free boost/week","⭐ 5 Super Likes/day","🔍 Advanced filters","🚫 No ads, ever","📍 Change location"];

  return (
    <div style={{ position: "absolute", inset: 0, background: "rgba(26,58,42,0.7)", backdropFilter: "blur(6px)", zIndex: 60, display: "flex", flexDirection: "column", justifyContent: "flex-end", borderRadius: 44, overflow: "hidden" }}>
      <div style={{ background: theme.warmWhite, borderRadius: "28px 28px 0 0", maxHeight: "90%", overflowY: "auto" }}>
        <div style={{ background: `linear-gradient(135deg,${theme.greenDeep},${theme.greenMid})`, padding: "32px 24px 28px", textAlign: "center", position: "relative" }}>
          <button onClick={onClose} style={{ position: "absolute", top: 14, right: 14, background: "rgba(255,255,255,0.15)", border: "none", color: "white", width: 28, height: 28, borderRadius: "50%", cursor: "pointer", fontSize: 14, display: "flex", alignItems: "center", justifyContent: "center" }}>✕</button>
          <div style={{ fontSize: 44, marginBottom: 10 }}>{msg.icon}</div>
          <div style={{ fontFamily: "Georgia,serif", fontSize: 21, fontWeight: 700, color: "white", marginBottom: 6 }}>{msg.title}</div>
          <p style={{ fontSize: 13, color: "rgba(255,255,255,0.75)", lineHeight: 1.5 }}>{msg.sub}</p>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 6, background: theme.gold, borderRadius: 50, padding: "5px 14px", marginTop: 12 }}>
            <span style={{ fontSize: 13 }}>👑</span>
            <span style={{ color: "white", fontWeight: 700, fontSize: 12, letterSpacing: "0.05em" }}>MEETFREE GOLD</span>
          </div>
        </div>

        <div style={{ padding: "18px 20px 0" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "7px 14px", marginBottom: 18 }}>
            {features.map(f => <div key={f} style={{ fontSize: 12, color: theme.textDark }}>{f}</div>)}
          </div>

          <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
            {plans.map(p => (
              <div key={p.id} onClick={() => setSelected(p.id)} style={{ flex: 1, borderRadius: 14, border: `2px solid ${selected === p.id ? theme.greenDeep : "rgba(82,183,136,0.2)"}`, background: selected === p.id ? theme.greenDeep : "white", padding: "10px 6px", textAlign: "center", cursor: "pointer", position: "relative", transition: "all 0.2s" }}>
                {p.badge && <div style={{ position: "absolute", top: -9, left: "50%", transform: "translateX(-50%)", background: theme.gold, color: "white", fontSize: 8, fontWeight: 700, padding: "2px 7px", borderRadius: 50, whiteSpace: "nowrap" }}>{p.badge.toUpperCase()}</div>}
                <div style={{ fontSize: 10, fontWeight: 600, color: selected === p.id ? "rgba(255,255,255,0.65)" : theme.textLight, marginBottom: 3 }}>{p.label}</div>
                <div style={{ fontFamily: "Georgia,serif", fontSize: 17, fontWeight: 700, color: selected === p.id ? "white" : theme.greenDeep }}>{p.price}</div>
                <div style={{ fontSize: 9, color: selected === p.id ? "rgba(255,255,255,0.55)" : theme.textLight }}>{p.per}</div>
              </div>
            ))}
          </div>

          <button onClick={() => onSubscribe(selected)} style={{ ...btnPrimary, background: `linear-gradient(135deg,${theme.greenDeep},${theme.greenMid})`, boxShadow: "0 8px 24px rgba(45,106,79,0.3)" }}>✨ Start my Gold membership</button>

          <div style={{ marginTop: 14, marginBottom: 4 }}>
            <div style={sectionLabel}>Or buy individually</div>
            <div style={{ display: "flex", gap: 8 }}>
              {[{ icon: "🚀", label: "Boost", desc: "30 min top spot", price: "£1.99" }, { icon: "⭐", label: "Super Likes", desc: "Pack of 5", price: "£2.49" }, { icon: "↩️", label: "Rewind", desc: "Undo last swipe", price: "£0.99" }].map(item => (
                <div key={item.label} style={{ flex: 1, background: "white", borderRadius: 12, padding: "10px 6px", textAlign: "center", border: "1px solid rgba(82,183,136,0.15)", cursor: "pointer" }}>
                  <div style={{ fontSize: 20, marginBottom: 3 }}>{item.icon}</div>
                  <div style={{ fontSize: 11, fontWeight: 700, color: theme.textDark }}>{item.label}</div>
                  <div style={{ fontSize: 9, color: theme.textLight, marginBottom: 4 }}>{item.desc}</div>
                  <div style={{ fontSize: 12, fontWeight: 700, color: theme.greenMid }}>{item.price}</div>
                </div>
              ))}
            </div>
          </div>

          <p style={{ textAlign: "center", fontSize: 10, color: theme.textLight, margin: "12px 0 22px", lineHeight: 1.5 }}>Cancel anytime. Billed via App Store / Google Play. Prices in GBP.</p>
        </div>
      </div>
    </div>
  );
};

// ─── WHO LIKED YOU TEASER ─────────────────────────────────────────────────────

const WhoLikedYou = ({ onUpgrade, currentUser, isPremium }) => {
  const [count, setCount] = useState(0);
  const emojis = ["🌿","🥑","🫐","🏃","🌺","🎵","🌊","🍄"];

  useEffect(() => {
    if (!currentUser) return;
    supabase
      .from("likes")
      .select("id", { count: "exact", head: true })
      .eq("to_user", currentUser.id)
      .then(({ count: c }) => setCount(c || 0));
  }, [currentUser]);

  if (count === 0) return null;

  return (
    <div style={{ margin: "0 16px 10px", borderRadius: 14, background: "white", border: "1px solid rgba(82,183,136,0.15)", overflow: "hidden", boxShadow: "0 2px 12px rgba(82,183,136,0.08)" }}>
      <div style={{ padding: "10px 14px 6px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: theme.textDark }}>
          💚 <span style={{ color: theme.greenMid }}>{count}</span> {count === 1 ? "person has" : "people have"} liked you
        </div>
        {!isPremium && <span style={{ fontSize: 10, background: theme.gold, color: "white", padding: "2px 8px", borderRadius: 50, fontWeight: 700 }}>GOLD</span>}
      </div>
      <div style={{ display: "flex", gap: 6, padding: "0 14px 12px", position: "relative", alignItems: "center" }}>
        {emojis.slice(0, Math.min(count, 5)).map((e, i) => (
          <div key={i} style={{ width: 48, height: 48, borderRadius: "50%", background: "linear-gradient(135deg,#d8f3dc,#b7e4c7)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, filter: isPremium ? "none" : "blur(5px)", userSelect: "none", transition: "filter 0.3s" }}>{e}</div>
        ))}
        {count > 5 && (
          <div style={{ width: 48, height: 48, borderRadius: "50%", background: theme.greenLight, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 700, color: theme.greenDeep, filter: isPremium ? "none" : "blur(5px)" }}>+{count - 5}</div>
        )}
        {!isPremium && (
          <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <button onClick={onUpgrade} style={{ background: theme.greenDeep, color: "white", border: "none", borderRadius: 50, padding: "7px 16px", fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "'DM Sans',sans-serif", boxShadow: "0 4px 12px rgba(26,58,42,0.3)" }}>👑 See who liked you</button>
          </div>
        )}
      </div>
    </div>
  );
};

// ─── SHARED COMPONENTS ────────────────────────────────────────────────────────

const PhoneShell = ({ children, statusBar = true }) => (
  <div style={{ width: 390, minHeight: 844, maxHeight: 844, background: theme.warmWhite, borderRadius: 44, overflow: "hidden", display: "flex", flexDirection: "column", position: "relative", fontFamily: "'DM Sans',sans-serif", boxShadow: "0 40px 100px rgba(26,58,42,0.25), 0 0 0 1px rgba(26,58,42,0.08)" }}>
    {statusBar && (
      <div style={{ background: theme.warmWhite, padding: "14px 28px 4px", display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0 }}>
        <span style={{ fontSize: 13, fontWeight: 600, color: theme.textDark }}>9:41</span>
        <div style={{ width: 120, height: 30, background: "#111", borderRadius: 20, margin: "0 auto" }} />
        <div style={{ display: "flex", gap: 5, alignItems: "center" }}><span style={{ fontSize: 11 }}>●●●</span><span style={{ fontSize: 13, fontWeight: 600 }}>📶</span></div>
      </div>
    )}
    <div style={{ flex: 1, overflowY: "hidden", display: "flex", flexDirection: "column" }}>{children}</div>
  </div>
);

const BottomNav = ({ active, onNav, isPremium, unreadCount = 0 }) => (
  <div style={{ display: "flex", borderTop: `1px solid rgba(82,183,136,0.15)`, background: "rgba(253,250,245,0.97)", backdropFilter: "blur(12px)", padding: "8px 0 20px", flexShrink: 0 }}>
    {[{ id: "swipe", icon: "💚", label: "Discover" }, { id: "chat", icon: "💬", label: "Messages" }, { id: "profile", icon: "🌿", label: "Profile" }, { id: "settings", icon: "⚙️", label: "Settings" }].map(t => (
      <button key={t.id} onClick={() => onNav(t.id)} style={{ flex: 1, background: "none", border: "none", cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", gap: 3, padding: "6px 0" }}>
        <div style={{ position: "relative" }}>
          <span style={{ fontSize: 22 }}>{t.icon}</span>
          {t.id === "chat" && unreadCount > 0 && (
            <div style={{ position: "absolute", top: -2, right: -4, minWidth: 16, height: 16, borderRadius: 50, background: "#e74c3c", color: "white", fontSize: 9, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center", padding: "0 3px" }}>{unreadCount > 9 ? "9+" : unreadCount}</div>
          )}
        </div>
        <span style={{ fontSize: 10, fontWeight: 600, letterSpacing: "0.04em", color: active === t.id ? theme.greenMid : theme.textLight, textTransform: "uppercase" }}>{t.label}</span>
        {active === t.id && <div style={{ width: 4, height: 4, borderRadius: "50%", background: theme.greenBright }} />}
      </button>
    ))}
  </div>
);

// ─── ONBOARDING ───────────────────────────────────────────────────────────────

const SignInForm = ({ onSuccess, onClose }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSignIn = async () => {
    if (!email || !password) { alert("Please enter your email and password"); return; }
    setLoading(true);
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });
    setLoading(false);
    if (error) { alert("Sign in failed: " + error.message); return; }
    onSuccess(data.user);
  };

  return (
    <div>
      <div style={{ marginBottom:14 }}>
        <label style={{ fontSize:12, fontWeight:600, color:theme.textMid, textTransform:"uppercase", letterSpacing:"0.05em", display:"block", marginBottom:6 }}>Email</label>
        <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="your@email.com" style={{ width:"100%", padding:"12px 16px", borderRadius:12, border:"2px solid rgba(82,183,136,0.2)", fontFamily:"'DM Sans',sans-serif", fontSize:14, outline:"none", boxSizing:"border-box" }} />
      </div>
      <div style={{ marginBottom:20 }}>
        <label style={{ fontSize:12, fontWeight:600, color:theme.textMid, textTransform:"uppercase", letterSpacing:"0.05em", display:"block", marginBottom:6 }}>Password</label>
        <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Your password" style={{ width:"100%", padding:"12px 16px", borderRadius:12, border:"2px solid rgba(82,183,136,0.2)", fontFamily:"'DM Sans',sans-serif", fontSize:14, outline:"none", boxSizing:"border-box" }} />
      </div>
      <button onClick={handleSignIn} disabled={loading} style={{ width:"100%", padding:"14px", borderRadius:50, border:"none", background:theme.greenDeep, color:"white", fontWeight:700, fontSize:16, cursor:"pointer", fontFamily:"'DM Sans',sans-serif", marginBottom:10, opacity:loading ? 0.7 : 1 }}>
        {loading ? "Signing in..." : "Sign in 🌱"}
      </button>
      <button onClick={onClose} style={{ width:"100%", padding:"12px", borderRadius:50, border:"2px solid rgba(82,183,136,0.2)", background:"none", color:theme.textMid, fontWeight:600, fontSize:14, cursor:"pointer", fontFamily:"'DM Sans',sans-serif" }}>
        Cancel
      </button>
    </div>
  );
};

const Onboarding = ({ onFinish, onShowSignIn }) => {
  const [step, setStep] = useState(0);
  const [data, setData] = useState({ diet: "Vegan", name: "", age: "", city: "", postcode: "", bio: "", interests: [], lookingFor: "", email: "", password: "" });
  const steps = [
    () => (
      <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "flex-start", padding: "1rem 2rem", textAlign: "center" }}>
        <div style={{ fontSize: 60, marginBottom: 12 }}>🌱</div>
        <div style={{ fontFamily: "Georgia,serif", fontSize: 28, fontWeight: 700, color: theme.greenDeep, lineHeight: 1.1, marginBottom: 12 }}>Meet<span style={{ color: theme.greenBright, fontStyle: "italic" }}>Free</span></div>
        <p style={{ color: theme.textMid, fontSize: 14, lineHeight: 1.5, maxWidth: 280, marginBottom: 24 }}>Connect with like-minded people who care — about animals, the planet, and each other.</p>
 <div style={{ width:"100%", marginBottom:16, background:"rgba(82,183,136,0.08)", borderRadius:16, padding:"16px", border:"1px solid rgba(82,183,136,0.2)", textAlign:"center" }}>
  <div style={{ fontSize:15, fontWeight:700, color:theme.greenDeep, marginBottom:6 }}>🎉 First 1,000 sign-ups get 3 months FREE Gold access!</div>
  <div style={{ fontSize:13, color:theme.textMid }}>Join today — it's completely free 🌱</div>
</div>
<button onClick={() => setStep(1)} style={btnPrimary}>Get started →</button>
        <p style={{ marginTop: 16, color: theme.textLight, fontSize: 13 }}>Already have an account? <span onClick={onShowSignIn} style={{ color: theme.greenMid, fontWeight: 600, cursor: "pointer" }}>Sign in</span></p>
      </div>
    ),
    () => (
      <div style={{ flex: 1, padding: "2rem" }}>
        <button onClick={() => setStep(0)} style={{ background:"none", border:"none", color:theme.greenMid, fontWeight:700, fontSize:14, cursor:"pointer", marginBottom:8, fontFamily:"'DM Sans',sans-serif", padding:0 }}>← Back</button>
        <ProgressBar step={1} total={5} />
        <h2 style={heading}>I eat a <span style={{ color: theme.greenBright, fontStyle: "italic" }}>{data.diet.toLowerCase()}</span> diet</h2>
        <p style={subText}>This helps us match you with like-minded people</p>
        {["Vegan","Vegetarian","Whole-food plant-based","Raw vegan"].map(d => (
          <button key={d} onClick={() => setData(p => ({ ...p, diet: d }))} style={{ ...optionBtn, background: data.diet === d ? theme.greenDeep : "white", color: data.diet === d ? "white" : theme.textDark, borderColor: data.diet === d ? theme.greenDeep : "rgba(82,183,136,0.25)" }}>
            {d === "Vegan" ? "🌱" : d === "Vegetarian" ? "🥗" : d === "Whole-food plant-based" ? "🥦" : "🥬"} {d}
          </button>
        ))}
        <button onClick={() => setStep(2)} style={{ ...btnPrimary, marginTop: 24 }}>Continue →</button>
      </div>
    ),
    () => (
      <div style={{ flex:1, padding:"2rem" }}>
        <button onClick={() => setStep(1)} style={{ background:"none", border:"none", color:theme.greenMid, fontWeight:700, fontSize:14, cursor:"pointer", marginBottom:8, fontFamily:"'DM Sans',sans-serif", padding:0 }}>← Back</button>
        <ProgressBar step={2} total={5} />
        <h2 style={heading}>I am here to find <span style={{ color:theme.greenBright, fontStyle:"italic" }}>{data.lookingFor || "..."}</span></h2>
        <p style={subText}>You can always change this later</p>
        {[
          { id:"Friends", icon:"🤝", desc:"Meet like-minded plant-based people" },
          { id:"Dating", icon:"💚", desc:"Find a partner who shares your values" },
          { id:"Both", icon:"🌱", desc:"Open to friendship and romance" },
          { id:"Community", icon:"🌍", desc:"Events, groups and local connections" },
        ].map(opt => (
          <button key={opt.id} onClick={() => setData(p => ({...p, lookingFor:opt.id}))} style={{ width:"100%", padding:"14px 18px", borderRadius:14, border:`2px solid ${data.lookingFor===opt.id ? theme.greenDeep : "rgba(82,183,136,0.25)"}`, background:data.lookingFor===opt.id ? theme.greenDeep : "white", color:data.lookingFor===opt.id ? "white" : theme.textDark, fontSize:15, fontWeight:500, cursor:"pointer", textAlign:"left", marginBottom:10, fontFamily:"'DM Sans',sans-serif", display:"flex", alignItems:"center", gap:12 }}>
            <span style={{ fontSize:22 }}>{opt.icon}</span>
            <div><div style={{ fontWeight:700 }}>{opt.id}</div><div style={{ fontSize:12, opacity:0.7 }}>{opt.desc}</div></div>
          </button>
        ))}
        <button onClick={() => setStep(3)} disabled={!data.lookingFor} style={{ ...btnPrimary, marginTop:16, opacity:data.lookingFor ? 1 : 0.5 }}>Continue →</button>
      </div>
    ),
    () => (
      <div style={{ flex: 1, padding: "2rem", overflowY: "auto" }}>
        <button onClick={() => setStep(2)} style={{ background:"none", border:"none", color:theme.greenMid, fontWeight:700, fontSize:14, cursor:"pointer", marginBottom:8, fontFamily:"'DM Sans',sans-serif", padding:0 }}>← Back</button>
        <ProgressBar step={3} total={5} />
        <h2 style={heading}>Tell us about <span style={{ color: theme.greenBright, fontStyle: "italic" }}>you</span></h2>
        <p style={subText}>Your profile info</p>
        {[{ label: "First name", key: "name", placeholder: "e.g. Sophie", type: "text" }, { label: "Age", key: "age", placeholder: "e.g. 28", type: "number" }, { label: "City", key: "city", placeholder: "e.g. London", type: "text" }, { label: "Postcode area", key: "postcode", placeholder: "e.g. BH, SO, SW1", type: "text" }, { label: "Email", key: "email", placeholder: "your@email.com", type: "email" }, { label: "Password", key: "password", placeholder: "Min 6 characters", type: "password" }].map(f => (
          <div key={f.key} style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: theme.textMid, letterSpacing: "0.05em", textTransform: "uppercase", display: "block", marginBottom: 6 }}>{f.label}</label>
            <input type={f.type} placeholder={f.placeholder} value={data[f.key]} onChange={e => setData(p => ({ ...p, [f.key]: e.target.value }))} style={inputStyle} />
          </div>
        ))}
        <button onClick={() => setStep(4)} style={{ ...btnPrimary, marginTop: 8 }}>Continue →</button>
      </div>
    ),
    () => (
      <div style={{ flex: 1, padding: "2rem" }}>
        <button onClick={() => setStep(3)} style={{ background:"none", border:"none", color:theme.greenMid, fontWeight:700, fontSize:14, cursor:"pointer", marginBottom:8, fontFamily:"'DM Sans',sans-serif", padding:0 }}>← Back</button>
        <ProgressBar step={4} total={6} />
        <h2 style={heading}>About <span style={{ color: theme.greenBright, fontStyle: "italic" }}>you</span></h2>
        <p style={subText}>A short bio helps you get more matches</p>
        <textarea
          placeholder="e.g. Vegan chef, dog lover and hiking enthusiast. Looking for someone to explore plant-based restaurants with! 🌱"
          value={data.bio}
          onChange={e => setData(p => ({ ...p, bio: e.target.value }))}
          rows={5}
          style={{ ...inputStyle, resize: "none", fontSize: 14, lineHeight: 1.6 }}
        />
        <div style={{ textAlign: "right", fontSize: 11, color: theme.textLight, marginTop: 4 }}>{(data.bio || "").length}/300</div>
        <button onClick={() => setStep(5)} style={{ ...btnPrimary, marginTop: 16 }}>Continue →</button>
        <button onClick={() => setStep(5)} style={{ ...btnGhost, marginTop: 10 }}>Skip for now</button>
      </div>
    ),
    () => (
      <div style={{ flex: 1, padding: "2rem" }}>
        <button onClick={() => setStep(4)} style={{ background:"none", border:"none", color:theme.greenMid, fontWeight:700, fontSize:14, cursor:"pointer", marginBottom:8, fontFamily:"'DM Sans',sans-serif", padding:0 }}>← Back</button>
        <ProgressBar step={5} total={6} />
        <h2 style={heading}>What are you <span style={{ color: theme.greenBright, fontStyle: "italic" }}>into?</span></h2>
        <p style={subText}>Pick up to 5 interests</p>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginTop: 16 }}>
          {["🧘 Yoga","🚴 Cycling","🎨 Art","🏃 Running","🍳 Cooking","✈️ Travel","🌍 Activism","📚 Reading","🎵 Music","🏔️ Hiking","📸 Photography","🌱 Gardening"].map(i => {
            const active = data.interests.includes(i);
            return <button key={i} onClick={() => setData(p => ({ ...p, interests: active ? p.interests.filter(x => x !== i) : p.interests.length < 5 ? [...p.interests, i] : p.interests }))} style={{ padding: "10px 16px", borderRadius: 50, border: `2px solid ${active ? theme.greenDeep : "rgba(82,183,136,0.25)"}`, background: active ? theme.greenDeep : "white", color: active ? "white" : theme.textDark, fontSize: 14, fontWeight: 500, cursor: "pointer", fontFamily: "'DM Sans',sans-serif" }}>{i}</button>;
          })}
        </div>
        <button onClick={() => setStep(6)} style={{ ...btnPrimary, marginTop: 24 }}>Continue →</button>
      </div>
    ),
    () => (
      <div style={{ flex: 1, padding: "2rem", display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
        <button onClick={() => setStep(5)} style={{ background:"none", border:"none", color:theme.greenMid, fontWeight:700, fontSize:14, cursor:"pointer", marginBottom:8, fontFamily:"'DM Sans',sans-serif", padding:0, alignSelf:"flex-start" }}>← Back</button>
        <ProgressBar step={6} total={6} />
        <div style={{ fontSize: 72, marginBottom: 16 }}>📸</div>
        <h2 style={{ ...heading, textAlign: "center" }}>Add your <span style={{ color: theme.greenBright, fontStyle: "italic" }}>photo</span></h2>
        <p style={{ ...subText, textAlign: "center", marginBottom: 12 }}>Profiles with photos get 8× more matches</p>
        <div style={{ width: 160, height: 160, borderRadius: "50%", background: "linear-gradient(135deg,rgba(82,183,136,0.15),rgba(149,213,178,0.1))", border: `3px dashed rgba(82,183,136,0.3)`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 40, cursor: "pointer", marginBottom: 12 }}>➕</div>
        <button onClick={() => onFinish(data)} style={btnPrimary}>Let's go! 🌱</button>
        <button onClick={() => onFinish(data)} style={{ ...btnGhost, marginTop: 12 }}>Skip for now</button>
      </div>
    ),
  ];
  return (
    <PhoneShell statusBar={false}>
      <div style={{ flex: 1, display: "flex", flexDirection: "column", background: theme.warmWhite }}>{steps[step]()}</div>
    </PhoneShell>
  );
};

const ProgressBar = ({ step, total }) => (
  <div style={{ display: "flex", gap: 6, marginBottom: 28 }}>
    {Array.from({ length: total }).map((_, i) => <div key={i} style={{ flex: 1, height: 4, borderRadius: 2, background: i < step ? theme.greenBright : "rgba(82,183,136,0.15)", transition: "background 0.3s" }} />)}
  </div>
);

// ─── PROFILE CARD ─────────────────────────────────────────────────────────────

const ProfileCard = ({ p, onLike, likedProfiles, onMessage }) => {
  const isReal = typeof p.id === "string" && p.id.length > 10;
  const key = isReal ? "supabase_" + p.id : "dummy_" + p.name;
  const isLiked = likedProfiles[key] || false;
  const diet = p.diet || "Vegan";
  const interests = Array.isArray(p.interests) ? p.interests : (p.interests ? String(p.interests).split(",") : []);

  return (
    <div style={{ borderRadius: 20, overflow: "hidden", boxShadow: "0 4px 20px rgba(0,0,0,0.07)", background: theme.warmWhite, marginBottom: 14 }}>
      <div style={{ height: 220, background: "linear-gradient(135deg,#d8f3dc,#b7e4c7)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 90, position: "relative", overflow:"hidden" }}>
        {p.photo_url
          ? <img src={p.photo_url} alt={p.name} style={{ width:"100%", height:"100%", objectFit:"cover", position:"absolute", inset:0 }} />
          : <span style={{ zIndex:1 }}>{p.emoji || "🌿"}</span>
        }
        <div style={{ position:"absolute", top:10, right:10, background:theme.greenDeep, color:"white", fontSize:11, fontWeight:700, padding:"4px 10px", borderRadius:50, zIndex:2 }}>
          {diet === "Vegan" ? "🌱" : "🥗"} {diet}
        </div>
      </div>
      <div style={{ padding: "14px 16px" }}>
        <div style={{ fontFamily:"Georgia,serif", fontSize:20, fontWeight:700, color:theme.greenDeep, marginBottom:2 }}>{p.name || "Someone"}{p.age ? `, ${p.age}` : ""}</div>
        <div style={{ fontSize:12, color:theme.textMid, marginBottom:8 }}>📍 {p.city || "Somewhere"}</div>
        {p.bio && <p style={{ fontSize:13, color:theme.textMid, lineHeight:1.7, marginBottom:10 }}>{p.bio}</p>}
        {interests.length > 0 && (
          <div style={{ display:"flex", gap:6, flexWrap:"wrap", marginBottom:12 }}>
            {interests.map(int => <span key={int} style={{ background:"rgba(82,183,136,0.1)", color:theme.greenMid, fontSize:11, fontWeight:600, padding:"3px 10px", borderRadius:50 }}>{String(int).trim()}</span>)}
          </div>
        )}
        {isLiked ? (
          <div style={{ display:"flex", gap:8 }}>
            <div style={{ flex:1, padding:"13px", borderRadius:50, border:`2px solid ${theme.greenBright}`, background:theme.greenBright, color:"white", fontSize:14, fontWeight:700, textAlign:"center" }}>✓ Liked</div>
            <button
              onClick={() => onMessage && onMessage(p)}
              style={{ flex:2, padding:"13px", borderRadius:50, border:"none", background:theme.greenMid, color:"white", fontSize:14, fontWeight:700, cursor:"pointer", fontFamily:"'DM Sans',sans-serif" }}
            >💬 Message {p.name}</button>
          </div>
        ) : (
          <button
            onClick={() => onLike(p)}
            style={{ width:"100%", padding:"13px", borderRadius:50, border:"2px solid rgba(82,183,136,0.25)", background:"white", color:theme.greenMid, fontSize:15, fontWeight:700, cursor:"pointer", fontFamily:"'DM Sans',sans-serif", transition:"all 0.2s" }}
          >💚 Like {p.name || "them"}</button>
        )}
      </div>
    </div>
  );
};

// ─── DISCOVER SCREEN (full list style) ───────────────────────────────────────

const SwipeScreen = ({ onNav, isPremium, onUpgrade, currentUser, likedProfiles, setLikedProfiles, onLogout, onOpenChat, unreadCount = 0 }) => {
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const liked = likedProfiles;
  const setLiked = setLikedProfiles;
  const [matchPopup, setMatchPopup] = useState(null);
  const [waitingPopup, setWaitingPopup] = useState(null);
  const [paywallTrigger, setPaywallTrigger] = useState(null);
  const [likesLeft, setLikesLeft] = useState(FREE_SWIPE_LIMIT);
  const [matchedIds, setMatchedIds] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useState({ diet: "", lookingFor: "", ageMin: "", ageMax: "", postcode: "", interests: [] });
  const [activeFilters, setActiveFilters] = useState({ diet: "", lookingFor: "", ageMin: "", ageMax: "", postcode: "", interests: [] });

  useEffect(() => {
    const loadMatches = async () => {
      if (!currentUser) return;
      const { data } = await supabase.from("matches").select("*").or(`user1.eq.${currentUser.id},user2.eq.${currentUser.id}`);
      if (data) {
        const ids = data.map(m => m.user1 === currentUser.id ? m.user2 : m.user1);
        setMatchedIds(ids);
      }
    };
    loadMatches();
  }, [currentUser]);

  useEffect(() => {
    const fetchProfiles = async () => {
      setLoading(true);

      // Fetch current user's interests for smart sorting
      let myInterests = [];
      if (currentUser?.id) {
        const { data: myProfile } = await supabase.from("profiles").select("interests").eq("id", currentUser.id).maybeSingle();
        if (myProfile?.interests) {
          myInterests = Array.isArray(myProfile.interests) ? myProfile.interests : String(myProfile.interests).split(",").map(i => i.trim());
        }
      }

      // Helper to count shared interests
      const sharedCount = (p) => {
        if (!myInterests.length) return 0;
        const theirInterests = Array.isArray(p.interests) ? p.interests : (p.interests ? String(p.interests).split(",").map(i => i.trim()) : []);
        return theirInterests.filter(i => myInterests.some(mi => mi.toLowerCase().includes(i.toLowerCase().replace(/^[^\w]+/, '')) || i.toLowerCase().includes(mi.toLowerCase().replace(/^[^\w]+/, '')))).length;
      };

      let query = supabase.from("profiles").select("*");
      if (currentUser?.id) query = query.neq("id", currentUser.id);
      if (activeFilters.diet) query = query.eq("diet", activeFilters.diet);
      if (activeFilters.lookingFor) query = query.eq("looking_for", activeFilters.lookingFor);
      if (activeFilters.ageMin) query = query.gte("age", parseInt(activeFilters.ageMin));
      if (activeFilters.ageMax) query = query.lte("age", parseInt(activeFilters.ageMax));
      if (activeFilters.postcode) query = query.ilike("postcode", activeFilters.postcode.toUpperCase() + "%");
      const { data, error } = await query;
      if (error) console.error("Fetch profiles error:", error);

      // Filter dummy profiles to match active filters
      let dummies = PROFILES;
      if (activeFilters.diet) dummies = dummies.filter(p => p.diet === activeFilters.diet);
      if (activeFilters.lookingFor) dummies = dummies.filter(p => p.looking_for === activeFilters.lookingFor);
      if (activeFilters.ageMin) dummies = dummies.filter(p => p.age >= parseInt(activeFilters.ageMin));
      if (activeFilters.ageMax) dummies = dummies.filter(p => p.age <= parseInt(activeFilters.ageMax));
      if (activeFilters.postcode) dummies = dummies.filter(p => p.postcode && p.postcode.toUpperCase().startsWith(activeFilters.postcode.toUpperCase()));
      if (activeFilters.interests?.length) dummies = dummies.filter(p => {
        const theirInterests = Array.isArray(p.interests) ? p.interests.map(i => i.toLowerCase()) : [];
        return activeFilters.interests.some(fi => theirInterests.some(ti => ti.includes(fi.toLowerCase())));
      });

      // Filter real profiles by interests if set
      let real2 = data || [];
      if (activeFilters.interests?.length) {
        real2 = real2.filter(p => {
          const theirInterests = Array.isArray(p.interests) ? p.interests.map(i => i.toLowerCase()) : (p.interests ? String(p.interests).toLowerCase() : "");
          return activeFilters.interests.some(fi => Array.isArray(theirInterests) ? theirInterests.some(ti => ti.includes(fi.toLowerCase())) : theirInterests.includes(fi.toLowerCase()));
        });
      }

      // Sort by shared interests — most compatible first
      const combined = [...real2, ...dummies].sort((a, b) => sharedCount(b) - sharedCount(a));
      setProfiles(combined);
      setLoading(false);
    };
    fetchProfiles();
  }, [currentUser, activeFilters]);

  const handleLike = async (profile) => {
    const isReal = typeof profile.id === "string" && profile.id.length > 10;
    const key = isReal ? "supabase_" + profile.id : "dummy_" + profile.name;
    if (liked[key]) return;
    setLiked(prev => ({ ...prev, [key]: true }));

    if (currentUser && isReal) {
      try {
        await supabase.from("likes").insert({ from_user: currentUser.id, to_user: profile.id });
        const { data: mutual } = await supabase.from("likes").select("id").eq("from_user", profile.id).eq("to_user", currentUser.id).single();
        if (mutual) {
          const [u1, u2] = [currentUser.id, profile.id].sort();
          await supabase.from("matches").upsert({ user1: u1, user2: u2 }, { onConflict: "user1,user2" });
          setMatchPopup(profile);
          setMatchedIds(prev => [...prev, profile.id]);
          // Send match email notification to both users
          try {
            const { data: myProfile } = await supabase.from("profiles").select("name,email").eq("id", currentUser.id).single();
            await supabase.functions.invoke("send-match-email", {
              body: {
                user1_email: myProfile?.email || currentUser.email,
                user1_name: myProfile?.name || "Someone",
                user2_email: profile.email,
                user2_name: profile.name,
              }
            });
          } catch(emailErr) { console.error("Email error:", emailErr); }
        }
      } catch(e) { console.error("Like error:", e); }
    }
  };

  if (loading) return (
    <PhoneShell>
      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 12 }}>
        <div style={{ fontSize: 40 }}>🌱</div>
        <div style={{ color: theme.textMid, fontSize: 14 }}>Finding people near you...</div>
      </div>
      <BottomNav active="swipe" onNav={onNav} isPremium={isPremium} unreadCount={unreadCount} />
    </PhoneShell>
  );

  return (
    <PhoneShell>
      {matchPopup && (
        <div style={{ position:"absolute", inset:0, zIndex:200, background:"rgba(26,58,42,0.95)", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", borderRadius:44, padding:32, textAlign:"center" }}>
          <div style={{ fontSize:64, marginBottom:8 }}>🎉</div>
          <div style={{ fontFamily:"Georgia,serif", fontSize:28, fontWeight:700, color:"white", marginBottom:8 }}>It's a match!</div>
          <div style={{ color:"rgba(255,255,255,0.75)", fontSize:15, marginBottom:32 }}>You and {matchPopup.name} both liked each other 💚</div>
          <button onClick={() => { setMatchPopup(null); onNav("chat"); }} style={{ ...btnPrimary, background:theme.greenBright, marginBottom:12 }}>Send a message</button>
          <button onClick={() => setMatchPopup(null)} style={{ background:"none", border:"none", color:"rgba(255,255,255,0.6)", fontSize:14, cursor:"pointer", fontFamily:"'DM Sans',sans-serif" }}>Keep browsing</button>
        </div>
      )}
      {waitingPopup && (
        <div style={{ position:"absolute", inset:0, zIndex:200, background:"rgba(26,58,42,0.92)", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", borderRadius:44, padding:36, textAlign:"center" }}>
          <div style={{ fontSize:64, marginBottom:12 }}>{waitingPopup.emoji || "🌿"}</div>
          <div style={{ fontFamily:"Georgia,serif", fontSize:24, fontWeight:700, color:"white", marginBottom:10 }}>Waiting on {waitingPopup.name}</div>
          <div style={{ color:"rgba(255,255,255,0.75)", fontSize:15, lineHeight:1.7, marginBottom:32 }}>When {waitingPopup.name} likes you back you'll both be notified and can start chatting 💚</div>
          <button onClick={() => setWaitingPopup(null)} style={{ ...btnPrimary, background:theme.greenBright }}>Got it</button>
        </div>
      )}
      {paywallTrigger && <Paywall trigger={paywallTrigger} onClose={() => setPaywallTrigger(null)} onSubscribe={() => { setPaywallTrigger(null); onUpgrade(); }} />}

      {/* Header */}
      <div style={{ padding: "14px 20px 10px", display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0 }}>
        <div>
          <div style={{ fontFamily: "Georgia,serif", fontSize: 22, fontWeight: 700, color: theme.greenDeep }}>
            Meet<span style={{ color: theme.greenBright, fontStyle: "italic" }}>Free</span>
            {isPremium && <span style={{ marginLeft: 8, fontSize: 11, background: theme.gold, color: "white", padding: "2px 7px", borderRadius: 50, fontFamily: "'DM Sans',sans-serif", fontWeight: 700 }}>👑 GOLD</span>}
          </div>
          {currentUser && <div style={{ fontSize: 10, color: theme.textLight, marginTop: 1 }}>Signed in as {currentUser.email}</div>}
        </div>
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          {!isPremium && <span style={{ fontSize: 12, color: likesLeft <= 2 ? theme.accent : theme.textLight, fontWeight: 600 }}>{likesLeft} likes left</span>}
          <button onClick={() => setShowFilters(true)} style={{ background: "none", border: "none", fontSize: 20, cursor: "pointer", position:"relative" }}>
            🔍
            {Object.values(activeFilters).some(v => v) && <span style={{ position:"absolute", top:-2, right:-2, width:8, height:8, borderRadius:"50%", background:theme.greenBright }} />}
          </button>
          <button onClick={() => setPaywallTrigger("wholiked")} style={{ background: "none", border: "none", fontSize: 20, cursor: "pointer" }}>🔔</button>
          <button onClick={async () => { await supabase.auth.signOut(); onLogout(); }} style={{ background: "none", border: "1px solid rgba(224,122,95,0.3)", borderRadius: 50, padding: "5px 12px", fontSize: 12, fontWeight: 700, color: theme.accent, cursor: "pointer", fontFamily: "inherit" }}>Sign out</button>
        </div>
      </div>

      <WhoLikedYou currentUser={currentUser} isPremium={isPremium} onUpgrade={() => setPaywallTrigger("wholiked")} />

      {/* Profile list */}
      <div style={{ flex: 1, overflowY: "auto", padding: "0 12px 8px" }}>
        {profiles.length === 0 ? (
          <div style={{ display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", height:"100%", textAlign:"center", padding:32 }}>
            <div style={{ fontSize:48, marginBottom:16 }}>🌍</div>
            <div style={{ fontFamily:"Georgia,serif", fontSize:20, color:theme.greenDeep, marginBottom:8 }}>No one here yet</div>
            <div style={{ color:theme.textMid, fontSize:14, lineHeight:1.6 }}>Check back soon as more plant-based people join!</div>
          </div>
        ) : (() => {
            const getKey = (p) => (typeof p.id === "string" && p.id.length > 10) ? "supabase_" + p.id : "dummy_" + p.name;
            const likedOnes = profiles.filter(p => liked[getKey(p)]);
            const rest = profiles.filter(p => !liked[getKey(p)]);
            const sorted = [...likedOnes, ...rest];
            return sorted.map((p, i) => {
              const showLikedHeader = i === 0 && likedOnes.length > 0;
              const showAllHeader = i === likedOnes.length && likedOnes.length > 0;
              return (
                <div key={String(p.id)+"_"+(p.name||"")}>
                  {showLikedHeader && <div style={{ fontSize:11, fontWeight:700, color:theme.greenBright, textTransform:"uppercase", letterSpacing:"0.08em", marginBottom:8 }}>💚 People you've liked</div>}
                  {showAllHeader && <div style={{ fontSize:11, fontWeight:700, color:theme.textLight, textTransform:"uppercase", letterSpacing:"0.08em", margin:"16px 0 8px" }}>Discover more</div>}
                  <ProfileCard p={p} onLike={handleLike} likedProfiles={liked} matchedIds={matchedIds} onMessage={(person) => {
                    const isReal = typeof person.id === "string" && person.id.length > 10;
                    if (isReal && matchedIds.includes(person.id)) {
                      // Find the match record and open chat directly
                      supabase.from("matches").select("*")
                        .or(`user1.eq.${currentUser.id},user2.eq.${currentUser.id}`)
                        .then(({ data }) => {
                          const match = (data || []).find(m => 
                            (m.user1 === person.id && m.user2 === currentUser.id) ||
                            (m.user2 === person.id && m.user1 === currentUser.id)
                          );
                          if (match && onOpenChat) { onOpenChat({ ...person, matchId: match.id }); onNav("chat"); }
                          else { onNav("chat"); }
                        });
                    } else { setWaitingPopup(person); }
                  }} />
                </div>
              );
            });
          })()}
      </div>
      <BottomNav active="swipe" onNav={onNav} isPremium={isPremium} unreadCount={unreadCount} />

      {/* Filter panel */}
      {showFilters && (
        <div style={{ position:"absolute", inset:0, zIndex:300, borderRadius:44, display:"flex", flexDirection:"column", justifyContent:"flex-end" }}>
          <div onClick={() => setShowFilters(false)} style={{ flex:1, background:"rgba(0,0,0,0.4)" }} />
          <div style={{ background:"white", borderRadius:"24px 24px 44px 44px", padding:"24px 24px 40px", maxHeight:"80%", overflowY:"auto" }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
              <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                <div style={{ fontFamily:"Georgia,serif", fontSize:20, fontWeight:700, color:theme.greenDeep }}>Filter people</div>
                <div style={{ position:"relative", display:"inline-block" }} className="filter-hint">
                  <div style={{ width:18, height:18, borderRadius:"50%", background:theme.greenBright, color:"white", fontSize:11, fontWeight:700, display:"flex", alignItems:"center", justifyContent:"center", cursor:"help" }}>?</div>
                  <div style={{ position:"absolute", left:0, top:24, width:220, background:theme.greenDeep, color:"white", fontSize:12, lineHeight:1.5, padding:"10px 12px", borderRadius:10, zIndex:10, boxShadow:"0 4px 16px rgba(0,0,0,0.2)", pointerEvents:"none" }} className="filter-hint-text">You don't need to fill in every filter — but the more you choose, the better your matches will be!</div>
                </div>
              </div>
              <button onClick={() => setShowFilters(false)} style={{ background:"none", border:"none", fontSize:22, cursor:"pointer", color:theme.textLight }}>✕</button>
            </div>

            {/* Diet */}
            <div style={{ marginBottom:18 }}>
              <div style={{ fontSize:12, fontWeight:700, color:theme.textLight, textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:8 }}>Diet</div>
              <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                {["", "Vegan", "Vegetarian", "Whole-food plant-based", "Plant-curious"].map(d => (
                  <button key={d} onClick={() => setFilters(f => ({ ...f, diet: d }))} style={{ padding:"6px 14px", borderRadius:50, border:`2px solid ${filters.diet === d ? theme.greenBright : "rgba(82,183,136,0.2)"}`, background: filters.diet === d ? theme.greenBright : "white", color: filters.diet === d ? "white" : theme.textMid, fontSize:12, fontWeight:600, cursor:"pointer", fontFamily:"inherit" }}>{d || "Any"}</button>
                ))}
              </div>
            </div>

            {/* Looking for */}
            <div style={{ marginBottom:18 }}>
              <div style={{ fontSize:12, fontWeight:700, color:theme.textLight, textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:8 }}>Looking for</div>
              <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                {["", "Dating", "Friendship", "Community", "Activity partner"].map(l => (
                  <button key={l} onClick={() => setFilters(f => ({ ...f, lookingFor: l }))} style={{ padding:"6px 14px", borderRadius:50, border:`2px solid ${filters.lookingFor === l ? theme.greenBright : "rgba(82,183,136,0.2)"}`, background: filters.lookingFor === l ? theme.greenBright : "white", color: filters.lookingFor === l ? "white" : theme.textMid, fontSize:12, fontWeight:600, cursor:"pointer", fontFamily:"inherit" }}>{l || "Any"}</button>
                ))}
              </div>
            </div>

            {/* Age range */}
            <div style={{ marginBottom:18 }}>
              <div style={{ fontSize:12, fontWeight:700, color:theme.textLight, textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:8 }}>Age range</div>
              <div style={{ display:"flex", gap:10, alignItems:"center" }}>
                <input type="number" placeholder="Min" value={filters.ageMin} onChange={e => setFilters(f => ({ ...f, ageMin: e.target.value }))} style={{ width:70, padding:"8px 12px", borderRadius:10, border:"2px solid rgba(82,183,136,0.2)", fontSize:14, fontFamily:"inherit", outline:"none" }} />
                <span style={{ color:theme.textLight }}>—</span>
                <input type="number" placeholder="Max" value={filters.ageMax} onChange={e => setFilters(f => ({ ...f, ageMax: e.target.value }))} style={{ width:70, padding:"8px 12px", borderRadius:10, border:"2px solid rgba(82,183,136,0.2)", fontSize:14, fontFamily:"inherit", outline:"none" }} />
              </div>
            </div>

            {/* Postcode */}
            <div style={{ marginBottom:18 }}>
              <div style={{ fontSize:12, fontWeight:700, color:theme.textLight, textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:8 }}>Postcode area</div>
              <input type="text" placeholder="e.g. BH, SO, SW1" value={filters.postcode} onChange={e => setFilters(f => ({ ...f, postcode: e.target.value }))} style={{ width:"100%", padding:"10px 14px", borderRadius:10, border:"2px solid rgba(82,183,136,0.2)", fontSize:14, fontFamily:"inherit", outline:"none" }} />
              <div style={{ fontSize:11, color:theme.textLight, marginTop:4 }}>Enter the first part of a UK postcode</div>
            </div>

            {/* Interests */}
            <div style={{ marginBottom:24 }}>
              <div style={{ fontSize:12, fontWeight:700, color:theme.textLight, textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:8 }}>Interests</div>
              <div style={{ display:"flex", flexWrap:"wrap", gap:8 }}>
                {["Yoga","Cycling","Art","Running","Cooking","Travel","Activism","Reading","Music","Hiking","Photography","Gardening","Meditation","Writing","Animals","Sport","Football","Film","Coffee","Wellness"].map(i => {
                  const active = filters.interests.includes(i);
                  return <button key={i} onClick={() => setFilters(f => ({ ...f, interests: active ? f.interests.filter(x => x !== i) : [...f.interests, i] }))} style={{ padding:"6px 12px", borderRadius:50, border:`2px solid ${active ? theme.greenBright : "rgba(82,183,136,0.2)"}`, background: active ? theme.greenBright : "white", color: active ? "white" : theme.textMid, fontSize:12, fontWeight:600, cursor:"pointer", fontFamily:"inherit" }}>{i}</button>;
                })}
              </div>
            </div>

            <div style={{ display:"flex", gap:10 }}>
              <button onClick={() => { const empty = { diet:"", lookingFor:"", ageMin:"", ageMax:"", postcode:"", interests:[] }; setFilters(empty); setActiveFilters(empty); setShowFilters(false); }} style={{ flex:1, padding:"12px", borderRadius:50, border:`2px solid rgba(82,183,136,0.2)`, background:"white", color:theme.textMid, fontWeight:700, fontSize:14, cursor:"pointer", fontFamily:"inherit" }}>Clear</button>
              <button onClick={() => { setActiveFilters({ ...filters }); setShowFilters(false); }} style={{ flex:2, padding:"12px", borderRadius:50, border:"none", background:theme.greenDeep, color:"white", fontWeight:700, fontSize:14, cursor:"pointer", fontFamily:"inherit" }}>Apply filters 🌱</button>
            </div>
          </div>
        </div>
      )}
    </PhoneShell>
  );
};

// ─── CHAT LIST ────────────────────────────────────────────────────────────────

const ChatList = ({ onNav, onOpenChat, isPremium, onUpgrade, currentUser, onLogout }) => {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMatches = async () => {
      if (!currentUser) { setLoading(false); return; }
      const { data, error } = await supabase
        .from("matches")
        .select("*")
        .or(`user1.eq.${currentUser.id},user2.eq.${currentUser.id}`);
      if (error) { console.error("Matches error:", error); setLoading(false); return; }

      // Fetch the other user's profile for each match
      const enriched = await Promise.all((data || []).map(async m => {
        const otherId = m.user1 === currentUser.id ? m.user2 : m.user1;
        const { data: profile } = await supabase.from("profiles").select("*").eq("id", otherId).single();
        return { ...m, profile };
      }));
      setMatches(enriched.filter(m => m.profile));
      setLoading(false);
    };
    fetchMatches();
  }, [currentUser]);

  return (
    <PhoneShell>
      <div style={{ padding: "16px 24px 8px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h1 style={{ fontFamily: "Georgia,serif", fontSize: 26, fontWeight: 700, color: theme.greenDeep }}>Messages</h1>
        <button onClick={async () => { await supabase.auth.signOut(); onLogout(); }} style={{ background: "none", border: `1px solid rgba(224,122,95,0.3)`, borderRadius: 50, padding: "5px 12px", fontSize: 12, fontWeight: 700, color: theme.accent, cursor: "pointer", fontFamily: "'DM Sans',sans-serif" }}>Sign out</button>
      </div>
      {!isPremium && <AdBanner onUpgrade={onUpgrade} />}

      {loading ? (
        <div style={{ flex:1, display:"flex", alignItems:"center", justifyContent:"center" }}>
          <div style={{ color: theme.textMid, fontSize: 14 }}>Loading matches...</div>
        </div>
      ) : matches.length === 0 ? (
        <div style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:32, textAlign:"center" }}>
          <div style={{ fontSize:48, marginBottom:16 }}>💚</div>
          <div style={{ fontFamily:"Georgia,serif", fontSize:20, color:theme.greenDeep, marginBottom:8 }}>No matches yet</div>
          <div style={{ color:theme.textMid, fontSize:14, lineHeight:1.6, marginBottom:24 }}>Like someone on Discover to start a conversation 💚</div>
          <button onClick={() => onNav("swipe")} style={btnPrimary}>Discover people 🌱</button>
        </div>
      ) : (
        <>
          <div style={{ padding: "0 24px 14px" }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: theme.textLight, letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: 10 }}>Your Matches</div>
            <div style={{ display: "flex", gap: 14, overflowX: "auto", paddingBottom: 4 }}>
              {matches.map(m => (
                <div key={m.id} onClick={() => onOpenChat({ ...m.profile, matchId: m.id })} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 5, cursor: "pointer" }}>
                  <div style={{ width: 54, height: 54, borderRadius: "50%", background: "linear-gradient(135deg,#d8f3dc,#b7e4c7)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 26, border: `3px solid ${theme.greenBright}`, position: "relative", overflow:"hidden" }}>
                    {m.profile.photo_url
                      ? <img src={m.profile.photo_url} alt={m.profile.name} style={{ width:"100%", height:"100%", objectFit:"cover" }} />
                      : "🌿"
                    }
                    <div style={{ position: "absolute", bottom: 0, right: 0, width: 13, height: 13, borderRadius: "50%", background: "#4ade80", border: "2px solid white" }} />
                  </div>
                  <span style={{ fontSize: 10, color: theme.textMid, fontWeight: 500 }}>{m.profile.name}</span>
                </div>
              ))}
            </div>
          </div>
          <div style={{ height: 1, background: "rgba(82,183,136,0.1)", margin: "0 24px" }} />
          <div style={{ flex: 1, overflowY: "auto" }}>
            {matches.map(m => (
              <div key={m.id} onClick={() => onOpenChat({ ...m.profile, matchId: m.id })} style={{ display: "flex", gap: 14, padding: "13px 24px", alignItems: "center", cursor: "pointer" }}>
                <div style={{ width: 50, height: 50, borderRadius: "50%", background: "#d8f3dc", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24, flexShrink: 0, overflow:"hidden" }}>
                  {m.profile.photo_url ? <img src={m.profile.photo_url} alt={m.profile.name} style={{ width:"100%", height:"100%", objectFit:"cover" }} /> : "🌿"}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 3 }}>
                    <span style={{ fontWeight: 700, color: theme.textDark, fontSize: 15 }}>{m.profile.name}</span>
                    <span style={{ fontSize: 12, color: theme.textLight }}>New match!</span>
                  </div>
                  <span style={{ fontSize: 13, color: theme.textLight }}>Say hello 👋</span>
                </div>
              </div>
            ))}
            {!isPremium && (
              <div style={{ margin: "6px 20px 14px", background: "rgba(244,168,41,0.08)", border: "1px solid rgba(244,168,41,0.25)", borderRadius: 14, padding: "11px 14px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 700, color: theme.textDark }}>👑 See read receipts</div>
                  <div style={{ fontSize: 11, color: theme.textLight }}>Know when your message is seen</div>
                </div>
                <button onClick={onUpgrade} style={{ background: theme.gold, border: "none", color: "white", borderRadius: 50, padding: "5px 12px", fontSize: 11, fontWeight: 700, cursor: "pointer", fontFamily: "'DM Sans',sans-serif" }}>Gold</button>
              </div>
            )}
          </div>
        </>
      )}
      <BottomNav active="chat" onNav={onNav} isPremium={isPremium} />
    </PhoneShell>
  );
};

// ─── CHAT DETAIL ──────────────────────────────────────────────────────────────

const ChatDetail = ({ chat, onBack, onNav, isPremium, currentUser }) => {
  const [msgs, setMsgs] = useState([]);
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(true);
  const bottomRef = useRef(null);

  // Load messages and subscribe to realtime updates
  useEffect(() => {
    if (!chat.matchId) { setLoading(false); return; }
    const fetchMsgs = async () => {
      const { data } = await supabase.from("messages").select("*").eq("match_id", chat.matchId).order("created_at", { ascending: true });
      setMsgs(data || []);
      setLoading(false);
    };
    fetchMsgs();

    const poll = setInterval(async () => {
      const { data } = await supabase.from("messages").select("*").eq("match_id", chat.matchId).order("created_at", { ascending: true });
      if (data) setMsgs(data);
    }, 2000);

    return () => clearInterval(poll);
  }, [chat.matchId]);

  // Scroll to bottom when new messages arrive
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [msgs]);

  const send = async () => {
    console.log("send called", { text: text.trim(), currentUser: currentUser?.id, matchId: chat.matchId });
    if (!text.trim() || !currentUser || !chat.matchId) {
      console.log("send blocked - missing:", { text: !text.trim(), currentUser: !currentUser, matchId: !chat.matchId });
      return;
    }
    const content = text.trim();
    setText("");
    const { error } = await supabase.from("messages").insert({ match_id: chat.matchId, sender_id: currentUser.id, content });
    if (error) console.error("Insert error:", error);
  };

  return (
    <PhoneShell>
      <div style={{ padding: "12px 20px", display: "flex", alignItems: "center", gap: 12, borderBottom: "1px solid rgba(82,183,136,0.1)", flexShrink: 0 }}>
        <button onClick={onBack} style={{ background: "none", border: "none", fontSize: 22, cursor: "pointer" }}>←</button>
        <div style={{ width: 40, height: 40, borderRadius: "50%", background: "#d8f3dc", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, overflow:"hidden" }}>
          {chat.photo_url ? <img src={chat.photo_url} alt={chat.name} style={{ width:"100%", height:"100%", objectFit:"cover" }} /> : "🌿"}
        </div>
        <div style={{ flex: 1 }}><div style={{ fontWeight: 700, color: theme.textDark, fontSize: 16 }}>{chat.name}</div></div>
        <button style={iconBtn}>⋯</button>
      </div>
      <div style={{ flex: 1, padding: "16px 20px", display: "flex", flexDirection: "column", gap: 10, overflowY: "auto" }}>
        <div style={{ textAlign: "center", fontSize: 11, color: theme.textLight, marginBottom: 8 }}>You matched with {chat.name} 🌱</div>
        {loading ? (
          <div style={{ textAlign:"center", color: theme.textMid, fontSize:13 }}>Loading messages...</div>
        ) : msgs.length === 0 ? (
          <div style={{ textAlign:"center", color: theme.textMid, fontSize:13 }}>No messages yet — say hello! 👋</div>
        ) : (
          msgs.map(m => {
            const isMe = m.sender_id === currentUser?.id;
            return (
              <div key={m.id} style={{ display: "flex", justifyContent: isMe ? "flex-end" : "flex-start" }}>
                <div style={{ maxWidth: "72%", padding: "10px 14px", borderRadius: isMe ? "18px 18px 4px 18px" : "18px 18px 18px 4px", background: isMe ? theme.greenDeep : "white", color: isMe ? "white" : theme.textDark, fontSize: 14, lineHeight: 1.5, boxShadow: "0 2px 8px rgba(26,58,42,0.08)" }}>{m.content}</div>
              </div>
            );
          })
        )}
        <div ref={bottomRef} />
      </div>
      <div style={{ padding: "12px 16px 12px", display: "flex", gap: 10, alignItems: "center", borderTop: "1px solid rgba(82,183,136,0.1)", background: "white", flexShrink: 0 }}>
        <input value={text} onChange={e => setText(e.target.value)} onKeyDown={e => e.key === "Enter" && send()} placeholder="Message..." style={{ flex: 1, padding: "10px 16px", borderRadius: 50, border: "2px solid rgba(82,183,136,0.2)", background: theme.warmWhite, fontFamily: "'DM Sans',sans-serif", fontSize: 14, outline: "none" }} />
        <button onClick={send} style={{ width: 40, height: 40, borderRadius: "50%", background: theme.greenBright, border: "none", fontSize: 18, cursor: "pointer" }}>↑</button>
      </div>
      <BottomNav active="chat" onNav={onNav} isPremium={isPremium} />
    </PhoneShell>
  );
};

// ─── PROFILE ──────────────────────────────────────────────────────────────────

const ProfileScreen = ({ onNav, isPremium, onUpgrade, currentUser, onLogout, unreadCount = 0 }) => {
  const [user, setUser] = useState({ id: currentUser?.id, name: "My Profile", age: "", city: "", bio: "", diet: "Vegan" });
  const [editing, setEditing] = useState(false);
  const [editData, setEditData] = useState({ id: currentUser?.id, name: "My Profile", age: "", city: "", bio: "", diet: "Vegan" });
  const [uploading, setUploading] = useState(false);
  const [loadError, setLoadError] = useState(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    const loadProfile = async () => {
      try {
        const { data: { user: authUser } } = await supabase.auth.getUser();
        if (!authUser) {
          // Use currentUser prop as fallback
          const fallback = { id: currentUser?.id, email: currentUser?.email, name: "My Profile", age: "", city: "", bio: "", diet: "Vegan" };
          setUser(fallback); setEditData(fallback); return;
        }
        // Use .maybeSingle() instead of .single() — returns null instead of error when no row
        const { data, error } = await supabase.from("profiles").select("*").eq("id", authUser.id).maybeSingle();
        if (data) {
          setUser(data); setEditData(data);
        } else {
          const fallback = { id: authUser.id, email: authUser.email, name: authUser.email?.split("@")[0] || "My Profile", age: "", city: "", bio: "", diet: "Vegan" };
          setUser(fallback); setEditData(fallback);
        }
      } catch(e) {
        console.error("Profile load error:", e);
        const fallback = { id: currentUser?.id, email: currentUser?.email, name: "My Profile", age: "", city: "", bio: "", diet: "Vegan" };
        setUser(fallback); setEditData(fallback);
      }
    };
    loadProfile();
  }, []);

  const saveProfile = async () => {
    const { data: { user: authUser } } = await supabase.auth.getUser();
    const uid = authUser?.id || currentUser?.id;
    if (!uid) return;
    await supabase.from("profiles").update({
      name: editData.name,
      age: parseInt(editData.age) || null,
      city: editData.city,
      postcode: editData.postcode ? editData.postcode.toUpperCase() : "",
      looking_for: editData.looking_for || "",
      bio: editData.bio,
    }).eq("id", uid);
    setUser({...user, ...editData});
    setEditing(false);
  };

  if (!user) return (
    <PhoneShell>
      <div style={{ flex:1, display:"flex", alignItems:"center", justifyContent:"center", flexDirection:"column", gap:12 }}>
        <div style={{ color:theme.textMid, fontSize:14 }}>Loading profile...</div>
        {loadError && <div style={{ color:"red", fontSize:11, padding:"0 20px", textAlign:"center" }}>{String(loadError)}</div>}
      </div>
      <BottomNav active="profile" onNav={onNav} isPremium={isPremium} unreadCount={unreadCount} />
    </PhoneShell>
  );

  if (editing) return (
    <PhoneShell>
      <div style={{ padding:"16px 24px 8px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
        <h1 style={{ fontFamily:"Georgia,serif", fontSize:26, fontWeight:700, color:theme.greenDeep }}>Edit Profile</h1>
        <button onClick={() => setEditing(false)} style={iconBtn}>✕</button>
      </div>
      <div style={{ flex:1, overflowY:"auto", padding:"0 20px" }}>
        {[
          { label:"Name", key:"name", type:"text" },
          { label:"Age", key:"age", type:"number" },
          { label:"City", key:"city", type:"text" },
          { label:"Postcode area", key:"postcode", type:"text", placeholder:"e.g. BH, SO, SW1" },
        ].map(f => (
          <div key={f.key} style={{ marginBottom:16 }}>
            <label style={{ fontSize:12, fontWeight:600, color:theme.textMid, textTransform:"uppercase", letterSpacing:"0.05em", display:"block", marginBottom:6 }}>{f.label}</label>
            <input type={f.type} placeholder={f.placeholder || ""} value={editData[f.key] || ""} onChange={e => setEditData(p => ({...p, [f.key]:e.target.value}))} style={{ width:"100%", padding:"12px 16px", borderRadius:12, border:"2px solid rgba(82,183,136,0.2)", fontFamily:"'DM Sans',sans-serif", fontSize:14, outline:"none", boxSizing:"border-box" }} />
          </div>
        ))}
        <div style={{ marginBottom:16 }}>
          <label style={{ fontSize:12, fontWeight:600, color:theme.textMid, textTransform:"uppercase", letterSpacing:"0.05em", display:"block", marginBottom:6 }}>Looking for</label>
          <select value={editData.looking_for || ""} onChange={e => setEditData(p => ({...p, looking_for:e.target.value}))} style={{ width:"100%", padding:"12px 16px", borderRadius:12, border:"2px solid rgba(82,183,136,0.2)", fontFamily:"'DM Sans',sans-serif", fontSize:14, outline:"none", boxSizing:"border-box", background:"white" }}>
            <option value="">Select...</option>
            {["Dating","Friendship","Community","Activity partner"].map(o => <option key={o} value={o}>{o}</option>)}
          </select>
        </div>
        <div style={{ marginBottom:16 }}>
          <label style={{ fontSize:12, fontWeight:600, color:theme.textMid, textTransform:"uppercase", letterSpacing:"0.05em", display:"block", marginBottom:6 }}>Bio</label>
          <textarea value={editData.bio || ""} onChange={e => setEditData(p => ({...p, bio:e.target.value}))} rows={4} style={{ width:"100%", padding:"12px 16px", borderRadius:12, border:"2px solid rgba(82,183,136,0.2)", fontFamily:"'DM Sans',sans-serif", fontSize:14, outline:"none", boxSizing:"border-box", resize:"none" }} />
        </div>
        <button onClick={saveProfile} style={{ ...btnPrimary, width:"100%", marginBottom:10, marginTop:10 }}>Save changes</button>
      </div>
      <BottomNav active="profile" onNav={onNav} isPremium={isPremium} unreadCount={unreadCount} />
    </PhoneShell>
  );

  return (
    <PhoneShell>
      <div style={{ padding: "16px 24px 8px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h1 style={{ fontFamily: "Georgia,serif", fontSize: 26, fontWeight: 700, color: theme.greenDeep }}>My Profile</h1>
        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={async () => { await supabase.auth.signOut(); onLogout(); }} style={{ background: "none", border: "1px solid rgba(224,122,95,0.3)", borderRadius: 50, padding: "5px 12px", fontSize: 12, fontWeight: 700, color: theme.accent, cursor: "pointer", fontFamily: "inherit" }}>Sign out</button>
          <button onClick={() => setEditing(true)} style={iconBtn}>✏️</button>
        </div>
      </div>
      <div style={{ flex: 1, overflowY: "auto" }}>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "18px 0 14px" }}>
          <label style={{ cursor:"pointer", display:"flex", flexDirection:"column", alignItems:"center", marginBottom:10 }}>
            <div style={{ position:"relative", marginBottom:10 }}>
              <div style={{ width: 96, height: 96, borderRadius: "50%", background: "linear-gradient(135deg,#d8f3dc,#b7e4c7)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 46, border: `4px solid ${isPremium ? theme.gold : theme.greenBright}`, boxShadow: isPremium ? `0 8px 24px rgba(244,168,41,0.3)` : "0 8px 24px rgba(82,183,136,0.2)", overflow:"hidden" }}>
                {user.photo_url
                  ? <img src={user.photo_url} alt="profile" style={{ width:"100%", height:"100%", objectFit:"cover" }} />
                  : <span>🌿</span>
                }
              </div>
              <div style={{ position:"absolute", bottom:0, right:0, width:30, height:30, borderRadius:"50%", background:theme.greenBright, display:"flex", alignItems:"center", justifyContent:"center", fontSize:15, boxShadow:"0 2px 8px rgba(0,0,0,0.2)", border:"2px solid white" }}>{uploading ? "⏳" : "📷"}</div>
            </div>
            <div style={{ background:theme.greenBright, color:"white", fontWeight:700, fontSize:13, padding:"7px 18px", borderRadius:50, fontFamily:"'DM Sans',sans-serif", boxShadow:"0 4px 12px rgba(82,183,136,0.3)" }}>
              {uploading ? "⏳ Uploading..." : user.photo_url ? "📷 Change photo" : "📷 Add profile photo"}
            </div>
            <input type="file" accept="image/*" style={{ display:"none" }} onChange={async (e) => {
              const file = e.target.files[0];
              if (!file || !currentUser) return;
              setUploading(true);
              const ext = file.name.split(".").pop();
              const path = currentUser.id + "." + ext;
              const { error } = await supabase.storage.from("avatars").upload(path, file, { upsert: true });
              if (error) { console.error("Upload error:", error); setUploading(false); return; }
              const { data: { publicUrl } } = supabase.storage.from("avatars").getPublicUrl(path);
              await supabase.from("profiles").update({ photo_url: publicUrl }).eq("id", currentUser.id);
              setUser(u => ({ ...u, photo_url: publicUrl }));
              setUploading(false);
            }} />
          </label>
          <div style={{ fontFamily: "Georgia,serif", fontSize: 22, fontWeight: 700, color: theme.greenDeep }}>{user.name}, {user.age}</div>
          <div style={{ color: theme.textMid, fontSize: 13, marginTop: 3 }}>📍 {user.city}</div>
          <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
            <span style={{ background: theme.greenDeep, color: "white", fontSize: 11, fontWeight: 600, padding: "3px 10px", borderRadius: 50 }}>🌱 {user.diet || "Vegan"}</span>
            {isPremium && <span style={{ background: theme.gold, color: "white", fontSize: 11, fontWeight: 600, padding: "3px 10px", borderRadius: 50 }}>👑 Gold</span>}
          </div>
        </div>
        <div style={{ display: "flex", margin: "0 20px 14px", background: "rgba(82,183,136,0.06)", borderRadius: 14, overflow: "hidden", border: "1px solid rgba(82,183,136,0.12)" }}>
          {[["12","Likes"],["3","Matches"],["86%","Complete"]].map(([n,l]) => (
            <div key={l} style={{ flex: 1, padding: "12px 0", textAlign: "center", borderRight: "1px solid rgba(82,183,136,0.12)" }}>
              <div style={{ fontFamily: "Georgia,serif", fontSize: 19, fontWeight: 700, color: theme.greenDeep }}>{n}</div>
              <div style={{ fontSize: 9, color: theme.textLight, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em" }}>{l}</div>
            </div>
          ))}
        </div>
        <div style={{ margin: "0 20px 12px" }}>
          <div style={sectionLabel}>About me</div>
          <p style={{ fontSize: 14, color: theme.textMid, lineHeight: 1.7 }}>{user.bio || "No bio yet — tap edit to add one!"}</p>
        </div>
        <div style={{ margin: "0 20px 14px" }}>
          <div style={sectionLabel}>Interests</div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 7 }}>
            {(user.interests || []).map(i => <span key={i} style={{ background: "rgba(82,183,136,0.1)", color: theme.greenMid, fontSize: 12, fontWeight: 600, padding: "4px 12px", borderRadius: 50 }}>{i}</span>)}
          </div>
        </div>
        {!isPremium ? (
          <div onClick={onUpgrade} style={{ margin: "0 20px 16px", background: `linear-gradient(135deg,${theme.greenDeep},${theme.greenMid})`, borderRadius: 18, padding: "16px 18px", display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer" }}>
            <div><div style={{ color: "white", fontWeight: 700, fontSize: 14 }}>👑 Upgrade to Gold</div><div style={{ color: "rgba(255,255,255,0.65)", fontSize: 12, marginTop: 3 }}>Unlimited likes · No ads · See who likes you</div></div>
            <div style={{ background: theme.gold, color: "white", fontWeight: 700, padding: "7px 14px", borderRadius: 50, fontSize: 13 }}>From £4.99</div>
          </div>
        ) : (
          <div style={{ margin: "0 20px 16px", background: `linear-gradient(135deg,${theme.gold},#f5b942)`, borderRadius: 18, padding: "16px 18px" }}>
            <div style={{ color: "white", fontWeight: 700, fontSize: 14, marginBottom: 3 }}>👑 You're a Gold member!</div>
            <div style={{ color: "rgba(255,255,255,0.8)", fontSize: 12 }}>Renews 4 Mar 2027 · Manage subscription</div>
          </div>
        )}
        {!isPremium && <AdBanner onUpgrade={onUpgrade} />}
      </div>
      <BottomNav active="profile" onNav={onNav} isPremium={isPremium} unreadCount={unreadCount} />
    </PhoneShell>
  );
};

// ─── SETTINGS ─────────────────────────────────────────────────────────────────

const SettingsScreen = ({ onNav, onLogout, isPremium, onUpgrade }) => {
  const [notifs, setNotifs] = useState(true);
  const [loc, setLoc] = useState(true);
  const [distance, setDistance] = useState(25);
  const Toggle = ({ on, toggle }) => (
    <div onClick={toggle} style={{ width: 46, height: 25, borderRadius: 13, background: on ? theme.greenBright : "rgba(82,183,136,0.2)", position: "relative", cursor: "pointer", transition: "background 0.25s", flexShrink: 0 }}>
      <div style={{ position: "absolute", top: 3, left: on ? 24 : 3, width: 19, height: 19, borderRadius: "50%", background: "white", transition: "left 0.25s", boxShadow: "0 2px 6px rgba(0,0,0,0.15)" }} />
    </div>
  );
  const Row = ({ label, sub, right, locked, onPress }) => (
    <div onClick={onPress} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "13px 18px", borderBottom: "1px solid rgba(82,183,136,0.08)", cursor: onPress ? "pointer" : "default" }}>
      <div>
        <div style={{ fontSize: 14, fontWeight: 500, color: locked ? theme.textLight : theme.textDark, display: "flex", alignItems: "center", gap: 6 }}>{label}{locked && <span style={{ fontSize: 10, background: theme.gold, color: "white", padding: "1px 6px", borderRadius: 50, fontWeight: 700 }}>GOLD</span>}</div>
        {sub && <div style={{ fontSize: 11, color: theme.textLight, marginTop: 1 }}>{sub}</div>}
      </div>
      {right}
    </div>
  );
  return (
    <PhoneShell>
      <div style={{ padding: "16px 24px 8px" }}>
        <h1 style={{ fontFamily: "Georgia,serif", fontSize: 26, fontWeight: 700, color: theme.greenDeep }}>Settings</h1>
      </div>
      <div style={{ flex: 1, overflowY: "auto" }}>
        {!isPremium && (
          <div onClick={onUpgrade} style={{ margin: "6px 18px 10px", background: `linear-gradient(135deg,${theme.gold},#f5b942)`, borderRadius: 14, padding: "12px 16px", display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer" }}>
            <div><div style={{ color: "white", fontWeight: 700, fontSize: 13 }}>👑 Upgrade to Gold</div><div style={{ color: "rgba(255,255,255,0.8)", fontSize: 11 }}>Unlock all features from £4.99/mo</div></div>
            <span style={{ color: "white", fontSize: 18 }}>›</span>
          </div>
        )}
        <div style={{ margin: "4px 18px 8px" }}>
          <div style={sectionLabel}>Discovery</div>
          <div style={{ background: "white", borderRadius: 14, overflow: "hidden", border: "1px solid rgba(82,183,136,0.1)" }}>
            <Row label="Match with" right={<span style={{ fontSize: 13, color: theme.greenMid, fontWeight: 600 }}>Everyone ›</span>} />
            <div style={{ padding: "12px 18px", borderBottom: "1px solid rgba(82,183,136,0.08)" }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 7 }}>
                <span style={{ fontSize: 14, fontWeight: 500, color: theme.textDark }}>Distance</span>
                <span style={{ fontSize: 13, color: theme.greenMid, fontWeight: 600 }}>{distance} mi</span>
              </div>
              <input type="range" min={1} max={100} value={distance} onChange={e => setDistance(e.target.value)} style={{ width: "100%", accentColor: theme.greenBright }} />
            </div>
            <Row label="Change location" sub="Search anywhere" locked={!isPremium} right={isPremium ? <span style={{ fontSize: 13, color: theme.greenMid }}>›</span> : <button onClick={onUpgrade} style={{ background: theme.gold, border: "none", color: "white", fontSize: 10, fontWeight: 700, padding: "3px 9px", borderRadius: 50, cursor: "pointer", fontFamily: "'DM Sans',sans-serif" }}>Unlock</button>} />
          </div>
        </div>
        <div style={{ margin: "4px 18px 8px" }}>
          <div style={sectionLabel}>Notifications</div>
          <div style={{ background: "white", borderRadius: 14, overflow: "hidden", border: "1px solid rgba(82,183,136,0.1)" }}>
            <Row label="Push notifications" sub="Matches and messages" right={<Toggle on={notifs} toggle={() => setNotifs(n => !n)} />} />
            <Row label="Location services" right={<Toggle on={loc} toggle={() => setLoc(l => !l)} />} />
          </div>
        </div>
        <div style={{ margin: "4px 18px 8px" }}>
          <div style={sectionLabel}>Account</div>
          <div style={{ background: "white", borderRadius: 14, overflow: "hidden", border: "1px solid rgba(82,183,136,0.1)" }}>
            <Row label="Privacy policy" right={<span style={{ color: theme.textLight }}>›</span>} onPress={() => onNav("privacy")} />
            <Row label="Terms of service" right={<span style={{ color: theme.textLight }}>›</span>} onPress={() => onNav("terms")} />
            <Row label="Block & report" right={<span style={{ color: theme.textLight }}>›</span>} onPress={() => onNav("block")} />
            <div onClick={onLogout} style={{ padding: "13px 18px", cursor: "pointer" }}><span style={{ color: theme.accent, fontWeight: 600, fontSize: 14 }}>Sign out</span></div>
          </div>
        </div>
        <div style={{ padding: "8px 0 24px", textAlign: "center", color: theme.textLight, fontSize: 11, lineHeight: 1.8 }}>MeetFree v1.0.0<br/>© 2025 MeetFree. Made with 🌱</div>
      </div>
      <BottomNav active="settings" onNav={onNav} isPremium={isPremium} unreadCount={unreadCount} />
    </PhoneShell>
  );
};

// ─── BLOCK & REPORT SCREEN ────────────────────────────────────────────────────

const BlockReportScreen = ({ onBack, currentUser }) => {
  const [step, setStep] = useState("form"); // form | submitting | done
  const [reportedName, setReportedName] = useState("");
  const [reason, setReason] = useState("");
  const [details, setDetails] = useState("");

  const reasons = [
    "Inappropriate photos or content",
    "Harassment or threatening behaviour",
    "Fake profile or impersonation",
    "Spam or scam",
    "Underage user",
    "Other",
  ];

  const handleSubmit = async () => {
    if (!reportedName || !reason) return alert("Please fill in all required fields.");
    setStep("submitting");
    try {
      // 1. Save to Supabase
      await supabase.from("reports").insert({
        reported_by: currentUser?.id || null,
        reported_name: reportedName,
        reason,
        details,
        created_at: new Date().toISOString(),
      });
      // 2. Send email notification via mailto (best effort)
      const subject = encodeURIComponent(`MeetFree Report: ${reason}`);
      const body = encodeURIComponent(`Reported user: ${reportedName}\nReason: ${reason}\nDetails: ${details}\nReported by: ${currentUser?.email || "unknown"}`);
      window.open(`mailto:descoffey@gmail.com?subject=${subject}&body=${body}`);
    } catch(e) {
      console.error("Report error:", e);
    }
    setStep("done");
  };

  return (
    <PhoneShell>
      <div style={{ flex:1, overflowY:"auto", padding:"24px 20px" }}>
        <button onClick={onBack} style={{ background:"none", border:"none", color:theme.greenMid, fontWeight:700, fontSize:14, cursor:"pointer", marginBottom:20, fontFamily:"'DM Sans',sans-serif" }}>← Back</button>
        <h2 style={{ fontFamily:"Georgia,serif", fontSize:26, color:theme.greenDeep, marginBottom:6 }}>Block & Report</h2>

        {step === "done" ? (
          <div style={{ textAlign:"center", paddingTop:40 }}>
            <div style={{ fontSize:56, marginBottom:16 }}>✅</div>
            <div style={{ fontFamily:"Georgia,serif", fontSize:22, color:theme.greenDeep, marginBottom:10 }}>Report submitted</div>
            <div style={{ color:theme.textMid, fontSize:14, lineHeight:1.7, marginBottom:28 }}>Thank you for helping keep MeetFree safe. We'll review this report within 48 hours. The user has been blocked.</div>
            <button onClick={onBack} style={btnPrimary}>Done</button>
          </div>
        ) : (
          <>
            <p style={{ color:theme.textMid, fontSize:13, lineHeight:1.7, marginBottom:24 }}>Reports are reviewed within 48 hours. Submitting a false report may result in your account being suspended.</p>

            <div style={{ marginBottom:16 }}>
              <label style={{ fontSize:12, fontWeight:700, color:theme.textMid, textTransform:"uppercase", letterSpacing:"0.05em", display:"block", marginBottom:6 }}>Name of person to report *</label>
              <input
                type="text"
                placeholder="e.g. Sophie"
                value={reportedName}
                onChange={e => setReportedName(e.target.value)}
                style={{ ...inputStyle, fontSize:14 }}
              />
            </div>

            <div style={{ marginBottom:16 }}>
              <label style={{ fontSize:12, fontWeight:700, color:theme.textMid, textTransform:"uppercase", letterSpacing:"0.05em", display:"block", marginBottom:8 }}>Reason *</label>
              {reasons.map(r => (
                <button key={r} onClick={() => setReason(r)} style={{ width:"100%", padding:"11px 16px", borderRadius:12, border:`2px solid ${reason === r ? theme.greenDeep : "rgba(82,183,136,0.2)"}`, background: reason === r ? theme.greenDeep : "white", color: reason === r ? "white" : theme.textDark, fontSize:13, fontWeight:500, cursor:"pointer", textAlign:"left", fontFamily:"'DM Sans',sans-serif", marginBottom:8 }}>
                  {r}
                </button>
              ))}
            </div>

            <div style={{ marginBottom:24 }}>
              <label style={{ fontSize:12, fontWeight:700, color:theme.textMid, textTransform:"uppercase", letterSpacing:"0.05em", display:"block", marginBottom:6 }}>Additional details (optional)</label>
              <textarea
                placeholder="Please describe what happened..."
                value={details}
                onChange={e => setDetails(e.target.value)}
                rows={4}
                style={{ ...inputStyle, fontSize:13, resize:"none" }}
              />
            </div>

            <button onClick={handleSubmit} disabled={step === "submitting"} style={{ ...btnPrimary, opacity: step === "submitting" ? 0.7 : 1, marginBottom:12 }}>
              {step === "submitting" ? "Submitting..." : "Submit report & block user"}
            </button>
            <button onClick={onBack} style={btnGhost}>Cancel</button>
          </>
        )}
      </div>
    </PhoneShell>
  );
};

// ─── SHARED STYLES ────────────────────────────────────────────────────────────

const btnPrimary = { width: "100%", padding: "15px 0", borderRadius: 50, border: "none", background: theme.greenDeep, color: "white", fontSize: 16, fontWeight: 600, cursor: "pointer", fontFamily: "'DM Sans',sans-serif", letterSpacing: "0.01em" };
const btnGhost = { width: "100%", padding: "12px 0", borderRadius: 50, border: `2px solid rgba(82,183,136,0.25)`, background: "transparent", color: theme.greenDeep, fontSize: 15, fontWeight: 600, cursor: "pointer", fontFamily: "'DM Sans',sans-serif" };
const optionBtn = { width: "100%", padding: "14px 18px", borderRadius: 14, border: "2px solid", marginBottom: 10, fontSize: 15, fontWeight: 500, cursor: "pointer", textAlign: "left", fontFamily: "'DM Sans',sans-serif" };
const inputStyle = { width: "100%", padding: "13px 16px", borderRadius: 14, border: `2px solid rgba(82,183,136,0.2)`, fontFamily: "'DM Sans',sans-serif", fontSize: 15, outline: "none", background: "white", color: theme.textDark, boxSizing: "border-box" };
const iconBtn = { width: 36, height: 36, borderRadius: "50%", border: "1px solid rgba(82,183,136,0.2)", background: "white", cursor: "pointer", fontSize: 16, display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" };
const heading = { fontFamily: "Georgia,serif", fontSize: 28, fontWeight: 700, color: theme.greenDeep, lineHeight: 1.2, marginBottom: 8 };
const subText = { color: theme.textMid, fontSize: 14, lineHeight: 1.6, marginBottom: 12 };
const sectionLabel = { fontSize: 11, fontWeight: 700, color: theme.textLight, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 8 };

// ─── ROOT APP ─────────────────────────────────────────────────────────────────

export default function App() {
  const [screen, setScreen] = useState("onboarding");
  const [showSignIn, setShowSignIn] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [activeChat, setActiveChat] = useState(null);
  const [unreadCount, setUnreadCount] = useState(0);
  const [toast, setToast] = useState(null);
  const lastMessageCount = React.useRef(0);
  const knownMessageIds = React.useRef(new Set());
  const hasInitialized = React.useRef(false);

  const playChime = () => {
    try {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      const notes = [523, 659, 784];
      notes.forEach((freq, i) => {
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.type = "sine";
        osc.frequency.value = freq;
        gain.gain.setValueAtTime(0, ctx.currentTime + i * 0.15);
        gain.gain.linearRampToValueAtTime(0.15, ctx.currentTime + i * 0.15 + 0.05);
        gain.gain.linearRampToValueAtTime(0, ctx.currentTime + i * 0.15 + 0.3);
        osc.start(ctx.currentTime + i * 0.15);
        osc.stop(ctx.currentTime + i * 0.15 + 0.3);
      });
    } catch(e) {}
  };
  const [isPremium, setIsPremium] = useState(false);
  const [showPaywall, setShowPaywall] = useState(false);
  const [likedProfiles, setLikedProfiles] = useState({});

  const loadLikes = async (userId) => {
    const { data } = await supabase.from("likes").select("to_user").eq("from_user", userId);
    if (data) {
      const liked = {};
      data.forEach(row => { liked["supabase_" + row.to_user] = true; });
      setLikedProfiles(liked);
    }
  };

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session?.user) {
        setCurrentUser(session.user);
        loadLikes(session.user.id);
        setScreen("swipe");
      }
    });
  }, []);

  // Use a ref for screen so interval always has current value
  const screenRef = React.useRef(screen);
  useEffect(() => { screenRef.current = screen; }, [screen]);

  // Poll for new messages every 8 seconds
  useEffect(() => {
    if (!currentUser) return;
    console.log("Starting message polling for", currentUser.id);
    
    const checkUnread = async () => {
      console.log("Polling...", new Date().toLocaleTimeString());
      const { data: matches } = await supabase.from("matches").select("id").or(`user1.eq.${currentUser.id},user2.eq.${currentUser.id}`);
      if (!matches?.length) return;
      let count = 0;
      let newMsg = null;
      for (const match of matches) {
        const { data: msgs } = await supabase.from("messages").select("id,sender_id,content").eq("match_id", match.id).neq("sender_id", currentUser.id);
        if (msgs?.length) {
          count += msgs.length;
          for (const msg of msgs) {
            if (!knownMessageIds.current.has(msg.id)) {
              if (hasInitialized.current) newMsg = msg;
              knownMessageIds.current.add(msg.id);
            }
          }
        }
      }
      hasInitialized.current = true;
      const onChat = screenRef.current === "chat";
      setUnreadCount(onChat ? 0 : count);
      if (newMsg && !onChat) {
        const { data: profile } = await supabase.from("profiles").select("name").eq("id", newMsg.sender_id).maybeSingle();
        console.log("New message from", profile?.name);
        setToast({ name: profile?.name || "Someone" });
        playChime();
        setTimeout(() => setToast(null), 4000);
      }
    };
    checkUnread();
    const interval = setInterval(checkUnread, 8000);
    return () => clearInterval(interval);
  }, [currentUser]);

  const handleNav = (s) => { setScreen(s); setActiveChat(null); if (s === "chat") setUnreadCount(0); };
  const handleUpgrade = () => setShowPaywall(true);
  const handleSubscribe = () => { setIsPremium(true); setShowPaywall(false); };

  return (
    <div style={{ minHeight: "100vh", background: "linear-gradient(135deg,#e8f5e9 0%,#f1f8e9 50%,#e0f2f1 100%)", display: "flex", alignItems: "flex-start", justifyContent: "center", padding: "20px 20px", fontFamily: "'DM Sans',sans-serif", overflowY: "auto" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&display=swap');
        .filter-hint-text { display: none; }
        .filter-hint:hover .filter-hint-text { display: block; }
        @keyframes slideDown { from { opacity:0; transform:translateX(-50%) translateY(-10px); } to { opacity:1; transform:translateX(-50%) translateY(0); } }
        * { box-sizing: border-box; }
        ::-webkit-scrollbar { display: none; }
        input[type=range] { height: 4px; border-radius: 2px; }
      `}</style>

      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 24 }}>
        {/* Toast notification */}
        {toast && (
          <div onClick={() => { setToast(null); handleNav("chat"); }} style={{ position:"fixed", top:20, left:"50%", transform:"translateX(-50%)", background:theme.greenDeep, color:"white", padding:"12px 20px", borderRadius:50, fontSize:13, fontWeight:600, fontFamily:"'DM Sans',sans-serif", boxShadow:"0 8px 24px rgba(26,58,42,0.3)", zIndex:9999, cursor:"pointer", whiteSpace:"nowrap", display:"flex", alignItems:"center", gap:8, animation:"slideDown 0.3s ease" }}>
            <span>💬</span>
            <span>New message from {toast.name}</span>
            <span style={{ opacity:0.7, fontSize:11 }}>Tap to open</span>
          </div>
        )}
        {/* Screen tabs — only show when not logged in */}
        {!currentUser && <div style={{ display: "flex", gap: 7, flexWrap: "wrap", justifyContent: "center" }}>
          {[
            { id: "onboarding", label: "🌱 Onboarding" },
            { id: "swipe", label: "💚 Discover" },
            { id: "chat", label: "💬 Messages" },
            { id: "profile", label: "🌿 Profile" },
            { id: "settings", label: "⚙️ Settings" },
            { id: "paywall", label: "👑 Paywall" },
          ].map(s => (
            <button key={s.id} onClick={() => { if (s.id === "paywall") { setShowPaywall(true); if (screen === "onboarding") setScreen("swipe"); } else handleNav(s.id); }} style={{ padding: "7px 16px", borderRadius: 50, border: "none", background: screen === s.id && s.id !== "paywall" ? theme.greenDeep : "rgba(255,255,255,0.75)", color: screen === s.id && s.id !== "paywall" ? "white" : theme.textMid, fontFamily: "'DM Sans',sans-serif", fontWeight: 600, fontSize: 12, cursor: "pointer", backdropFilter: "blur(8px)", boxShadow: screen === s.id && s.id !== "paywall" ? "0 4px 16px rgba(26,58,42,0.25)" : "none" }}>{s.label}</button>
          ))}
        </div>}

        {/* Free / Gold toggle — only show when not logged in */}
        {!currentUser && <div style={{ display: "flex", alignItems: "center", gap: 10, background: "rgba(255,255,255,0.75)", backdropFilter: "blur(8px)", padding: "6px 16px", borderRadius: 50 }}>
          <span style={{ fontSize: 12, fontWeight: 600, color: theme.textMid }}>Preview as:</span>
          <button onClick={() => setIsPremium(false)} style={{ padding: "4px 12px", borderRadius: 50, border: "none", background: !isPremium ? theme.greenDeep : "transparent", color: !isPremium ? "white" : theme.textMid, fontFamily: "'DM Sans',sans-serif", fontWeight: 600, fontSize: 12, cursor: "pointer" }}>Free</button>
          <button onClick={() => setIsPremium(true)} style={{ padding: "4px 12px", borderRadius: 50, border: "none", background: isPremium ? theme.gold : "transparent", color: isPremium ? "white" : theme.textMid, fontFamily: "'DM Sans',sans-serif", fontWeight: 600, fontSize: 12, cursor: "pointer" }}>👑 Gold</button>
        </div>}

        {/* Phone */}
        <div style={{ position: "relative" }}>
          {showPaywall && (
            <div style={{ position: "absolute", inset: 0, zIndex: 100, borderRadius: 44, overflow: "hidden" }}>
              <Paywall trigger="generic" onClose={() => setShowPaywall(false)} onSubscribe={handleSubscribe} />
            </div>
          )}
          {showSignIn && (
  <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", zIndex:200, display:"flex", alignItems:"center", justifyContent:"center", padding:"20px" }}>
    <div style={{ background:"white", borderRadius:24, padding:"28px", width:"100%", maxWidth:380 }}>
      <h2 style={{ fontFamily:"Georgia,serif", fontSize:24, color:theme.greenDeep, marginBottom:8 }}>Welcome back 🌱</h2>
      <p style={{ color:theme.textMid, fontSize:14, marginBottom:20 }}>Sign in to your MeetFree account</p>
      <SignInForm onSuccess={(user) => { setCurrentUser(user); loadLikes(user.id); setShowSignIn(false); setScreen("swipe"); }} onClose={() => setShowSignIn(false)} />
    </div>
  </div>
)}
{screen === "onboarding" && <Onboarding onShowSignIn={() => setShowSignIn(true)} onFinish={async (profileData) => {
  try {
    const { data: authData, error: authError } = await supabase.auth.signUp({
      email: profileData.email,
      password: profileData.password,
    });
    if (authError) { alert("Signup error: " + authError.message); return; }
    const { error: profileError } = await supabase.from("profiles").insert({
      id: authData.user.id,
      email: profileData.email,
      name: profileData.name,
      age: parseInt(profileData.age),
      city: profileData.city,
      diet: profileData.diet,
      looking_for: profileData.lookingFor,
      postcode: profileData.postcode ? profileData.postcode.toUpperCase() : "",
      interests: profileData.interests,
      bio: profileData.bio || "",
    });
    if (profileError) console.error("Profile error:", profileError);
    setCurrentUser(authData.user);
    setScreen("swipe");
  } catch(e) { console.error(e); setScreen("swipe"); }
}} />}
          {screen === "swipe" && <SwipeScreen onNav={handleNav} isPremium={isPremium} onUpgrade={handleUpgrade} currentUser={currentUser} likedProfiles={likedProfiles} setLikedProfiles={setLikedProfiles} onLogout={() => { setCurrentUser(null); setScreen("onboarding"); }} onOpenChat={c => setActiveChat(c)} unreadCount={unreadCount} />}
          {screen === "chat" && !activeChat && <ChatList onNav={handleNav} onOpenChat={c => setActiveChat(c)} isPremium={isPremium} onUpgrade={handleUpgrade} currentUser={currentUser} onLogout={() => { setCurrentUser(null); setScreen("onboarding"); }} />}
          {screen === "chat" && activeChat && <ChatDetail chat={activeChat} onBack={() => setActiveChat(null)} onNav={handleNav} isPremium={isPremium} currentUser={currentUser} />}
          {screen === "profile" && <ProfileScreen onNav={handleNav} isPremium={isPremium} onUpgrade={handleUpgrade} currentUser={currentUser} onLogout={() => { setCurrentUser(null); setScreen("onboarding"); }} unreadCount={unreadCount} />}
          {screen === "settings" && <SettingsScreen onNav={handleNav} onLogout={() => setScreen("onboarding")} isPremium={isPremium} onUpgrade={handleUpgrade} />}
          {screen === "privacy" && (
            <PhoneShell>
              <div style={{ flex:1, overflowY:"auto", padding:"24px 20px" }}>
                <button onClick={() => setScreen("settings")} style={{ background:"none", border:"none", color:theme.greenMid, fontWeight:700, fontSize:14, cursor:"pointer", marginBottom:20, fontFamily:"'DM Sans',sans-serif" }}>← Back</button>
                <h2 style={{ fontFamily:"Georgia,serif", fontSize:26, color:theme.greenDeep, marginBottom:6 }}>Privacy Policy</h2>
                <p style={{ fontSize:11, color:theme.textLight, marginBottom:24 }}>Last updated: March 2026</p>
                {[
                  ["Who We Are", "MeetFree is a plant-based connections app helping people find friends, dates and community. This policy explains how we handle your personal data."],
                  ["What We Collect", "We collect your email address when you join our waiting list, and profile information (name, age, city, interests) when you register."],
                  ["Why We Collect It", "We use your data to provide the MeetFree service, match you with other users, and send you relevant notifications. We will never sell your data."],
                  ["Legal Basis", "We process your data based on your explicit consent given during registration. You can withdraw consent at any time by deleting your account."],
                  ["Data Storage", "Your data is stored securely using Supabase infrastructure with industry-standard encryption and security practices."],
                  ["How Long We Keep It", "We keep your data for as long as your account is active. If you delete your account, your data is permanently removed within 30 days."],
                  ["Your Rights", "Under GDPR you have the right to access, correct or delete your data at any time. Email us at descoffey@gmail.com and we will respond within 30 days."],
                  ["Cookies", "We use minimal cookies only to keep you logged in. We do not use tracking or advertising cookies."],
                  ["Contact Us", "For any privacy questions email descoffey@gmail.com or write to us at the address provided in our Terms & Conditions."],
                ].map(([title, text]) => (
                  <div key={title} style={{ marginBottom:20 }}>
                    <div style={{ fontWeight:700, color:theme.greenDeep, fontSize:15, marginBottom:6 }}>{title}</div>
                    <div style={{ color:theme.textMid, fontSize:13, lineHeight:1.7 }}>{text}</div>
                  </div>
                ))}
              </div>
            </PhoneShell>
          )}
          {screen === "terms" && (
            <PhoneShell>
              <div style={{ flex:1, overflowY:"auto", padding:"24px 20px" }}>
                <button onClick={() => setScreen("settings")} style={{ background:"none", border:"none", color:theme.greenMid, fontWeight:700, fontSize:14, cursor:"pointer", marginBottom:20, fontFamily:"'DM Sans',sans-serif" }}>← Back</button>
                <h2 style={{ fontFamily:"Georgia,serif", fontSize:26, color:theme.greenDeep, marginBottom:6 }}>Terms of Service</h2>
                <p style={{ fontSize:11, color:theme.textLight, marginBottom:24 }}>Last updated: March 2026</p>
                {[
                  ["1. Acceptance", "By creating a MeetFree account you agree to these Terms of Service. If you do not agree, please do not use the app."],
                  ["2. Eligibility", "You must be 18 or older to use MeetFree. By registering you confirm you meet this requirement."],
                  ["3. Your Account", "You are responsible for keeping your account credentials secure. Do not share your password. You are responsible for all activity on your account."],
                  ["4. Acceptable Use", "You agree not to use MeetFree to harass, abuse or harm others; post false or misleading information; impersonate another person; or engage in any unlawful activity."],
                  ["5. Content", "You retain ownership of content you post. By posting you grant MeetFree a licence to display that content within the app. We reserve the right to remove content that violates these terms."],
                  ["6. Subscriptions", "MeetFree Gold subscriptions are billed in advance. You may cancel at any time. Refunds are not provided for partial subscription periods unless required by law."],
                  ["7. Termination", "We reserve the right to suspend or terminate accounts that violate these terms, without notice."],
                  ["8. Limitation of Liability", "MeetFree is provided as-is. We are not liable for any indirect or consequential loss arising from your use of the app."],
                  ["9. Governing Law", "These terms are governed by the laws of England and Wales. Any disputes will be subject to the exclusive jurisdiction of the courts of England and Wales."],
                  ["10. Contact", "For any questions about these terms please email descoffey@gmail.com. Registered address: [Address placeholder — update before launch]."],
                ].map(([title, text]) => (
                  <div key={title} style={{ marginBottom:20 }}>
                    <div style={{ fontWeight:700, color:theme.greenDeep, fontSize:15, marginBottom:6 }}>{title}</div>
                    <div style={{ color:theme.textMid, fontSize:13, lineHeight:1.7 }}>{text}</div>
                  </div>
                ))}
              </div>
            </PhoneShell>
          )}
          {screen === "block" && <BlockReportScreen onBack={() => setScreen("settings")} currentUser={currentUser} />}
        </div>
      </div>
    </div>
  );
}
